import React, { useState, useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSecurityMaster } from "../../context/SecurityMasterContext";
import { useMarketIndicators } from "../../context/MarketIndicatorContext";
import { useWatchlist } from "../../context/WatchlistContext";
import { useIndicators } from "../../context/IndicatorContext";
// import { useStockName } from "../../context/StockNameContext";
import { useMoreStockContext } from "../../context/MoreStockContext";
import { useMarketToggle } from "../../context/MarketContext";
import { useAuth } from "../../context/AuthNewContext";
import Gauge from "../Gauge/Gauge";
import { FaSpinner } from "react-icons/fa6";
import { FiRefreshCw } from "react-icons/fi";
import { useAdmin } from "../../context/AdminContext";
import { useVariant } from "../../hooks/useVariant";
import { useAIChat } from "../../context/AIChatContext";
import { FiStar } from "react-icons/fi"; // outline
import { useMarket } from "../../context/MarketDhanContext";
import { useChartIndicator } from "../../context/ChartIndicatorContext";
import { FaStar, FaRegStar } from "react-icons/fa"; // filled

import UpgradeModal from "../UpgradeModal/UpgradeModal";

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  LineChart,
  Line,
  CartesianGrid,
  Legend,
  ComposedChart,
} from "recharts";

import { useOption } from "../../context/OptionContext";
import "./StockTest.css";
import RangeBarSVG from "../RangeSvg/RangeBarSVG";
import ChatPanel from "../ChatPanel/ChatPanel";
import AIFloatButton from "../AIFloatButton/AIFloatButton";
import Chat from "../Chat/Chat";
import { usePdf } from "../../context/PdfContext";
import ChatPanel2 from "../ChatPanel2/ChatPanel2";
import CandleChart from "../CandleChart/CandleChart";

const StockTest = () => {
  console.count("StockTest Render");
  const [securityId, setSecurityId] = useState();
  const [trend, setTrend] = useState("");
  const [loadingSecurity, setLoadingSecurity] = useState(false);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [lastUTSignal, setLastUTSignal] = useState(null);
  // const [analysis, setAnalysis] = useState(null);
  const [crossovers, setCrossovers] = useState([]); //crossover
  const [error, setError] = useState("");
  const { fetchBySymbol, pcr } = useOption();
  const { setMoreData } = useMoreStockContext();
  const [interval, setInterval] = useState("1d");
  const { fetchNewsData, newsError, newsLoading, newsData } = useIndicators();
  const [position, setPosition] = useState({
    inPosition: false,
    entryPrice: null,
  });
  const {
    getSecurityIdBySymbol,
    securityIdData,
    securityError,
    securityLoading,
  } = useMarket();
  const { getChartIndicators, chartIndicatorData } = useChartIndicator();

  const { downloadStockPDF } = usePdf();

  // 1d | 1w | 1m
  const [lastUpdated, setLastUpdated] = useState("");
  // const [variant, setVariant] = useState("desktop");
  const [liveReady, setLiveReady] = useState(false);
  const [visibleCount, setVisibleCount] = useState(8);

  const {
    indicatorData,
    fetchIndicators,
    getPrevClose,
    previousClose,
    quoteData,
    getMarketQuote,
    getMarketIntraday,
    intradayData,

    getTargetPrice,
    resetTargetPrice,
    targetPrice,
    getMarketCap,
    marketCapData,
    getStockStatistics,
    statsData,
    getReturnData,
    returnData,
    getNameBySymbol,
    stockName,
    getSma,
    maData,
    availableCandles,
    resetMarketData,

    loading,
  } = useMarketIndicators();
  const { user } = useAuth();
  const userID = user?.userID;
  // const { fetchStock, stockData } = useStockName();

  const { companyCode } = useParams();
  const navigate = useNavigate();
  const variant = useVariant();
  const { chatOpen } = useAIChat();

  // const { getSecurityIds } = useSecurityMaster();
  const {
    addToWatchlist,
    removeFromWatchlist,
    resetWatchlist,
    fetchWatchlist,
    watchlist,
    isInWatchlist,
  } = useWatchlist();
  const { fetchStockInfo } = useAdmin();
  const { market } = useMarketToggle();
  const [timeFrame, setTimeFrame] = useState("min");
  const [resistTimeFrame, setResistTimeFrame] = useState("day");
  // const loadSingleStock = async () => {
  //   const res = await getSecurityIds(companyCode);

  //   const securityId = res?.[0]?.security_id ?? null;
  //   setSecurityId(securityId);
  //   console.log("Security ID:", securityId);
  // };
  // const loadSingleStock = async () => {
  //   setLoadingSecurity(true);
  //   setError(null);

  //   const res = await getSecurityIds(companyCode);

  //   const id = res?.[0]?.security_id ?? null;
  //   setSecurityId(id);

  //   console.log("Security ID:", id);
  // };
  const loadSingleStock = async () => {
    try {
      setLoadingSecurity(true);

      setError(null);

      const res = await getSecurityIdBySymbol(companyCode);

      console.log("DB SECURITY RESULT", res);

      const id = Number(res?.security_id) || null;

      if (!id) {
        setError("Security ID not found");

        setLoadingSecurity(false);

        return;
      }

      // ✅ IMPORTANT
      setSecurityId(id);

      console.log("FINAL SECURITY ID", id);
    } catch (err) {
      console.error("Security ID Error", err);

      setError("Failed to load security ID");
    } finally {
      setLoadingSecurity(false);
    }
  };
  // console.log("Security Id", securityId);
  // useEffect(() => {
  //   if (!companyCode) return;

  //   fetchStock(companyCode);
  //   loadSingleStock();
  //   fetchBySymbol(companyCode);
  //   getPeerStock(companyCode);
  // }, [companyCode]);
  const formatTimestamp = () => {
    const now = new Date();

    const day = String(now.getDate()).padStart(2, "0");

    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[now.getMonth()];

    const year = now.getFullYear();

    const time = now.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });

    return `${day}-${month}-${year} ${time} IST`;
  };
  // useEffect(() => {
  //   console.log("🟡 securityId changed:", securityId);

  //   if (!securityId) {
  //     console.warn("⛔ fetchIndicators skipped: securityId missing");
  //     return;
  //   }

  //   fetchIndicators(securityId);
  //   getPrevClose(securityId);
  //   getMarketQuote(securityId);
  //   getMarketIntraday(securityId);
  //   setLastUpdated(formatTimestamp());
  // }, [securityId]);

  // console.log("Stock Name", stockData);
  console.log("Indicators", indicatorData);
  console.log("Quote data", quoteData);
  console.log("Previous Close", previousClose);
  console.log("Intraday data", intradayData);
  console.log("Watchlist", watchlist);
  // const quote = quoteData?.[securityId];
  // const quote = quoteData?.[security_id_db];
  // console.log("Quote", quote);
  console.log("pcr", pcr);

  const latestRSIValue =
    indicatorData?.indicators?.rsi?.length > 0
      ? indicatorData.indicators.rsi.at(-1).value
      : null;
  const latestMACDValue =
    indicatorData?.indicators?.macd?.length > 0
      ? indicatorData.indicators.macd.at(-1).macd
      : null;
  // const percent_change = (
  //   ((quote?.last_price - previousClose?.prevClose) /
  //     previousClose?.prevClose) *
  //   100
  // ).toFixed(2);

  console.log("Latest Rsi from dhan", latestRSIValue);
  console.log("Latest MAcd from dhan", latestMACDValue);
  const dates = indicatorData?.dates;
  const indicators = indicatorData?.indicators;

  const indicatorsMin = intradayData?.indicators;
  const masterTimelineMin = intradayData?.closeSeries || [];
  const masterTimelineDay = indicatorData?.closeSeries || [];
  console.log("Data close", masterTimelineDay);
  // const macdChartData =
  //   Array.isArray(indicators?.macd) &&
  //   indicators?.macd.map((row, i) => ({
  //     date: dates[i + (dates?.length - indicators?.macd?.length)] || null,

  //     MACD: row.macd ?? 0,
  //     signal: row.signal ?? 0,
  //     histogram: row.histogram ?? 0,
  //   }));
  // const macdChartDataMin =
  //   Array.isArray(indicatorsMin?.macd) &&
  //   indicatorsMin?.macd.map((row, i) => ({
  //     date:
  //       indicatorsMin?.dates[
  //         i + (indicatorsMin?.dates?.length - indicatorsMin?.macd?.length)
  //       ] || null,

  //     MACD: row.macd ?? 0,
  //     signal: row.signal ?? 0,
  //     histogram: row.histogram ?? 0,
  //   }));
  const macdChartDataMin = masterTimelineMin.map((p, i) => {
    const offset = masterTimelineMin.length - indicatorsMin.macd.length;
    const macdIndex = i - offset;

    if (macdIndex < 0) {
      return {
        date: p.date,
        MACD: null,
        signal: null,
        histogram: null,
      };
    }

    const m = indicatorsMin.macd[macdIndex];

    return {
      date: p.date, // 🔥 SAME AS PRICE
      MACD: m.macd,
      signal: m.signal,
      histogram: m.histogram,
    };
  });
  const macdChartData = masterTimelineDay.map((p, i) => {
    const offset = masterTimelineDay.length - indicators.macd.length;
    const macdIndex = i - offset;

    if (macdIndex < 0) {
      return {
        date: p.date,
        MACD: null,
        signal: null,
        histogram: null,
      };
    }

    const m = indicators.macd[macdIndex];

    return {
      date: p.date, // 🔥 SAME AS PRICE
      MACD: m.macd,
      signal: m.signal,
      histogram: m.histogram,
    };
  });
  // const selectedData =
  //   timeFrame === "min"
  //     ? Array.isArray(macdChartDataMin)
  //       ? macdChartDataMin
  //       : []
  //     : Array.isArray(macdChartData)
  //       ? macdChartData
  //       : [];
  //   const macdChartDataMin =
  //     Array.isArray(indicators?.macd) &&
  //    intradayData.indicators?.macd.map((row, i) => ({
  //       date:
  //         histoMin?.[i + (histoMin?.length - intradayIndicators?.macd?.length)]
  //           ?.date || i + 1,
  //       MACD: row.MACD ?? 0,
  //       signal: row.signal ?? 0,
  //       histogram: row.histogram ?? 0,
  //     }));
  console.log("Array macd chart from Dhan", macdChartData);
  console.log("Array macd chart from Dhan Min", macdChartDataMin);
  const rsiValue = intradayData?.indicators?.rsi;
  console.log("RSI VALUE", rsiValue);
  console.log("RSI VALUE", rsiValue?.[rsiValue?.length - 1]);
  const macdValue = intradayData?.indicators?.macd;
  console.log("MACD VALUE", macdValue);
  const latestRSIValueMin =
    intradayData?.indicators?.rsi?.length > 0
      ? indicatorData?.indicators?.rsi.at(-1).value
      : null;
  const latestMACDValueMin =
    intradayData?.indicators?.macd?.length > 0
      ? indicatorData?.indicators?.macd.at(-1).macd
      : null;
  console.log("Latest MIN Rsi from dhan", latestRSIValueMin);
  console.log("Latest MIN MAcd from dhan", latestMACDValueMin);
  const formatVolume = (volume) => {
    if (volume == null) return "-"; // catches null & undefined

    const num = Number(volume);
    if (!Number.isFinite(num)) return "-";

    return num.toLocaleString("en-IN");
  };

  const getInterpretation = (indicators) => {
    if (
      !indicators ||
      !Array.isArray(indicators.macd) ||
      !Array.isArray(indicators.rsi) ||
      indicators.macd.length === 0 ||
      indicators.rsi.length === 0
    ) {
      return {
        result: "Currently data not available. Kindly Refresh again",
        color: "#fbbf24",
        bgColor: "#FFF5CC",
        prediction: "Neutral",
      };
    }

    // ✅ Extract numeric values correctly
    const latestRSIObj = indicators.rsi.at(-1);
    const latestMACDObj = indicators.macd.at(-1);

    const latestRSI = latestRSIObj?.value;
    const macd = latestMACDObj?.macd;
    const signal = latestMACDObj?.signal;
    const histogram = latestMACDObj?.histogram;

    if (
      typeof latestRSI !== "number" ||
      typeof macd !== "number" ||
      typeof signal !== "number" ||
      typeof histogram !== "number"
    ) {
      return {
        result: "Indicator data incomplete",
        color: "#fbbf24",
        bgColor: "#FFF5CC",
        prediction: "Neutral",
      };
    }

    // --- RSI STATUS ---
    let rsiStatus = "Neutral";
    if (latestRSI >= 70) rsiStatus = "Overbought";
    else if (latestRSI <= 30) rsiStatus = "Oversold";
    else if (latestRSI > 50) rsiStatus = "Neutral-Bullish";
    else rsiStatus = "Neutral-Bearish";

    // --- MACD STATUS ---
    let macdStatus = "Neutral";
    if (macd > signal && histogram > 0) macdStatus = "Bullish";
    else if (macd < signal && histogram < 0) macdStatus = "Bearish";

    // --- STRONG ALIGNMENT ---
    if (latestRSI > 55 && macdStatus === "Bullish") {
      return {
        result: "Strong Bullish Momentum (RSI & MACD aligned)",
        color: "#249966",
        bgColor: "#D4F7E6",
        prediction: "Bullish",
      };
    }

    if (latestRSI < 45 && macdStatus === "Bearish") {
      return {
        result: "Strong Bearish Momentum (RSI & MACD aligned)",
        color: "#f87171",
        bgColor: "#FFE1E1",
        prediction: "Bearish",
      };
    }

    // --- DIVERGENCE ---
    if (
      (latestRSI > 50 && macd < signal && histogram < 0) ||
      (latestRSI < 50 && macd > signal && histogram > 0)
    ) {
      return {
        result: "Divergence detected – Possible reversal",
        color: "#fbbf24",
        bgColor: "#FFF5CC",
        prediction: "Neutral",
      };
    }

    // --- EXTREMES ---
    if (rsiStatus === "Overbought" && macdStatus === "Bullish") {
      return {
        result: "Overbought – Bullish but tiring",
        color: "#f59e0b",
        bgColor: "#FFF5CC",
        prediction: "Bearish",
      };
    }

    if (rsiStatus === "Oversold" && macdStatus === "Bearish") {
      return {
        result: "Oversold – Bearish but rebound possible",
        color: "#60a5fa",
        bgColor: "#DBEAFE",
        prediction: "Bullish",
      };
    }

    return {
      result: "Neutral / Sideways Market",
      color: "#9ca3af",
      bgColor: "#E5E7EB",
      prediction: "Neutral",
    };
  };

  const { result, color, bgColor, prediction } = getInterpretation(indicators);
  const {
    result: result1,
    color: color1,
    prediction: prediction1,
    bgColor: bgColor1,
  } = getInterpretation(indicatorsMin);
  console.log("Result from intrepretation", result, color, bgColor, prediction);
  console.log(
    "Result from intrepretation",
    result1,
    color1,
    bgColor1,
    prediction1,
  );

  const prev_close = previousClose?.prevClose;

  // const companyName = stockData?.name;
  // const peerCompany = peerData?.companyProfile?.peerCompanyList?.filter(
  //   (stock) => stock?.companyName?.toLowerCase() !== companyName?.toLowerCase(),
  // );
  // console.log("Peer Company", peerCompany);
  // const testNews = peerData?.recentNews;
  // console.log("test News", testNews);
  // const peerCompanyList=peerData?.companyProfile?.peerCompanyList;
  //  const mergedPeers = peerCompany?.map((peer) => {

  //   const match = peerPEData?.find(
  //     (p) =>
  //       p.name?.trim().toLowerCase() === peer?.companyName?.trim().toLowerCase()
  //   );

  //   return {
  //     ...peer,
  //     peRatio: match ? match.peRatio : "N/A",
  //   };
  // });
  // console.log("Matched", mergedPeers);
  //   const macdRange = useMemo(() => {
  //   if (!selectedData?.length) return [-5, 5];

  //   let min = Infinity;
  //   let max = -Infinity;

  //   selectedData.forEach((d) => {
  //     if (typeof d.macd === "number") {
  //       min = Math.min(min, d.macd);
  //       max = Math.max(max, d.macd);
  //     }
  //     if (typeof d.signal === "number") {
  //       min = Math.min(min, d.signal);
  //       max = Math.max(max, d.signal);
  //     }
  //     if (typeof d.histogram === "number") {
  //       min = Math.min(min, d.histogram);
  //       max = Math.max(max, d.histogram);
  //     }
  //   });

  //   const pad = Math.max(Math.abs(min), Math.abs(max)) * 0.25 || 1;

  //   return [
  //     Math.floor(min - pad),
  //     Math.ceil(max + pad),
  //   ];
  // }, [selectedData]);
  const handleRefresh = async () => {
    // fetchStock(companyCode);
    // loadSingleStock();
    fetchBySymbol(companyCode);
    fetchNewsData(companyCode);
    // getPeerStock(companyCode);
  };
  const getPositionPercent = (value, low, high) => {
    if (high === low) return 0;
    return ((value - low) / (high - low)) * 100;
  };

  //  Previous use Effect
  // useEffect(() => {
  //   if (!companyCode) return;

  //   // fetchStock(companyCode);
  //   fetchBySymbol(companyCode);
  //   // getPeerStock(companyCode);
  //   // getTargetPrice(companyCode);
  //   getMarketCap(companyCode);
  //   getStockStatistics(companyCode);
  //   getNameBySymbol(companyCode);

  //   const load = async () => {
  //     setLoadingSecurity(true);
  //     setError("");

  //     const res = await getSecurityIds(companyCode);
  //     const id = res?.[0]?.security_id ?? null;
  //     setSecurityId(id);
  //   };

  //   load();
  // }, [companyCode]);
  // New use effect
  // useEffect(() => {
  //   if (!companyCode) return;

  //   setLiveReady(false); // 🔥 RESET LIVE STATE
  //   setError("");

  //   fetchBySymbol(companyCode);
  //   getMarketCap(companyCode);
  //   getStockStatistics(companyCode, market);
  //   getNameBySymbol(companyCode);
  //   getTargetPrice(companyCode, market);
  //   fetchNewsData(companyCode);
  //   getSecurityIdBySymbol(companyCode);

  //   const load = async () => {
  //     setLoadingSecurity(true);
  //     const res = await getSecurityIds(companyCode);
  //     console.log("Result is", res);
  //     const id = res?.[0]?.security_id ?? null;
  //     setSecurityId(id);
  //   };

  //   load();
  // }, [companyCode]);
  // useEffect(()=>{
  //   getSecurityIdBySymbol(companyCode);
  // })
  // useEffect(() => {
  //   if (!loadingSecurity) return;

  //   const timer = setTimeout(() => {
  //     // console.log("OLD securityId:", securityId);
  //     console.log("DB security_id_db:", security_id_db);

  //     if (!security_id_db) {
  //       setError("❌ Market data not found for this stock");
  //       setLoadingSecurity(false);
  //     }
  //   }, 6000);

  //   return () => clearTimeout(timer);
  // }, [loadingSecurity, securityIdData]);
  // const security_id_db = useMemo(() => {
  //   return securityIdData?.security_id || null;
  // }, [securityIdData]);

  useEffect(() => {
    if (!securityId) return;

    fetchNewsData(companyCode);

    getChartIndicators({
      symbol: companyCode,

      securityId,

      interval: "5",
    });
  }, [securityId, companyCode]);
  console.log("chartIdicator data", chartIndicatorData);
  const bbgSignal = chartIndicatorData?.lastSignal?.text;

  // useEffect(() => {
  //   if (!security_id_db) {
  //     return;
  //   }

  //   const loadLiveData = async () => {
  //     setLiveReady(false);
  //     setError(null);

  //     try {
  //       const results = await Promise.allSettled([
  //         fetchIndicators(security_id_db),
  //         getPrevClose(security_id_db),

  //         getMarketQuote({
  //           securityId: Number(security_id_db),
  //           symbol: companyCode,
  //           userID,
  //         }),

  //         getMarketIntraday(security_id_db),
  //         getReturnData(security_id_db),
  //         getSma(security_id_db),
  //       ]);

  //       console.log("LIVE RESULTS", results);

  //       const quoteResult = results[2];

  //       // ❌ quote rejected
  //       if (quoteResult.status === "rejected") {
  //         console.error("Quote failed", quoteResult.reason);

  //         setError("Failed to load market quote");

  //         setLiveReady(false);

  //         return;
  //       }

  //       const quoteValue = quoteResult.value;

  //       // ❌ no quote data
  //       if (!quoteValue?.data || Object.keys(quoteValue.data).length === 0) {
  //         setError("Market data unavailable");

  //         setLiveReady(false);

  //         return;
  //       }

  //       // ✅ SUCCESS
  //       setError(null);

  //       setLastUpdated(formatTimestamp());

  //       setLiveReady(true);
  //     } catch (err) {
  //       console.error(err);

  //       setError("Unexpected market error");

  //       setLiveReady(false);
  //     }
  //   };

  //   loadLiveData();
  // }, [security_id_db]);
  // console.log("seucirty id", securityId);
  console.log("SecurityId from db", securityIdData);

  const quote = quoteData?.[securityId];
  const stock = quote?.ohlc;
  const percent_change = (
    ((quote?.last_price - previousClose?.prevClose) /
      previousClose?.prevClose) *
    100
  ).toFixed(2);
  console.log("Precent_change", percent_change);

  const depth = quote?.depth;
  console.log("Depth from quote", depth);
  const buyQty = depth?.buy?.reduce((s, b) => s + b.quantity, 0);
  const sellQty = depth?.sell?.reduce((s, s1) => s + s1.quantity, 0);
  const buyOrders = depth?.buy?.reduce((s, b) => s + b.orders, 0);
  const sellOrders = depth?.sell?.reduce((s, s1) => s + s1.orders, 0);
  const totalBuyQty = depth?.buy?.reduce(
    (sum, b) => sum + (b.quantity || 0),
    0,
  );

  const totalSellQty = depth?.sell?.reduce(
    (sum, s) => sum + (s.quantity || 0),
    0,
  );

  const totalQty = totalBuyQty + totalSellQty;

  const buyPercent = totalQty ? (totalBuyQty / totalQty) * 100 : 0;

  const sellPercent = totalQty ? (totalSellQty / totalQty) * 100 : 0;
  const open = stock?.open;
  const close = prev_close;

  const weekLow = quote?.["52_week_low"];
  const weekHigh = quote?.["52_week_high"];

  const last_price = quote?.last_price;
  const dayPosition = getPositionPercent(last_price, stock?.low, stock?.high);

  const weekPosition = getPositionPercent(last_price, weekLow, weekHigh);
  const EDGE_THRESHOLD = 8; // percent

  const isNearLow = dayPosition < EDGE_THRESHOLD;
  const isNearHigh = dayPosition > 100 - EDGE_THRESHOLD;
  console.log("Weel low and hogh", weekLow, weekHigh);
  // useEffect(() => {
  //   const updateVariant = () => {
  //     setVariant(window.innerWidth < 768 ? "mobile" : "desktop");
  //   };

  //   updateVariant(); // 👈 run once on mount
  //   window.addEventListener("resize", updateVariant);

  //   return () => window.removeEventListener("resize", updateVariant);
  // }, []);
  // old useffect
  // useEffect(() => {
  //   if (!securityId || error) return;

  //   fetchIndicators(securityId);
  //   getPrevClose(securityId);
  //   getMarketQuote(securityId);
  //   getMarketIntraday(securityId);
  //   getReturnData(securityId);
  //   getSma(securityId);

  //   setLastUpdated(formatTimestamp());
  //   setLiveReady(true);
  // }, [securityId]);

  // useEffect(() => {
  //   if (!securityId || error) return;

  //   const loadLiveData = async () => {
  //     try {
  //       await Promise.all([
  //         fetchIndicators(securityId),
  //         getPrevClose(securityId),
  //         getMarketQuote(securityId),
  //         getMarketIntraday(securityId),
  //         getReturnData(securityId),
  //         getSma(securityId),
  //         // getResistance(securityId),
  //       ]);

  //       setLastUpdated(formatTimestamp());
  //       setLiveReady(true);
  //     } catch (err) {
  //       setError("❌ Failed to load live market data");
  //       setLiveReady(false);
  //     }
  //   };

  //   loadLiveData();
  // }, [securityId]);
  // useEffect(() => {
  //   if (!securityId) return;

  //   const loadLiveData = async () => {
  //     try {
  //       const results = await Promise.allSettled([
  //         fetchIndicators(securityId),
  //         getPrevClose(securityId),
  //         getMarketQuote(securityId),
  //         getMarketIntraday(securityId),
  //         getReturnData(securityId),
  //         getSma(securityId),
  //       ]);

  //       // optional: log failed ones
  //       results.forEach((res, idx) => {
  //         if (res.status === "rejected") {
  //           console.warn(`Live API ${idx} failed`, res.reason);
  //         }
  //       });

  //       setLastUpdated(formatTimestamp());
  //       setLiveReady(true);
  //     } catch {
  //       // this rarely triggers now
  //       setError("❌ Unexpected error while loading live data");
  //       setLiveReady(false);
  //     }
  //   };

  //   loadLiveData();
  // }, [securityId]);

  const detectCrossovers = (data, priceData) => {
    const signals = [];

    for (let i = 1; i < data.length; i++) {
      const prev = data[i - 1];
      const curr = data[i];

      if (
        prev.MACD == null ||
        prev.signal == null ||
        curr.MACD == null ||
        curr.signal == null
      )
        continue;

      const price = priceData?.[i]?.close;

      // BUY crossover
      if (prev.MACD < prev.signal && curr.MACD > curr.signal) {
        signals.push({
          type: "BUY",
          date: curr.date,
          index: i,
          price,
          macd: curr.MACD,
          signal: curr.signal,
        });
      }

      // SELL crossover
      if (prev.MACD > prev.signal && curr.MACD < curr.signal) {
        signals.push({
          type: "SELL",
          date: curr.date,
          index: i,
          price,
          macd: curr.MACD,
          signal: curr.signal,
        });
      }
    }

    return signals;
  };

  const calculateTradePerformance = (signals, priceData) => {
    const trades = [];

    let activeTrade = null;

    for (let i = 0; i < signals.length; i++) {
      const signal = signals[i];

      // =========================
      // BUY ENTRY
      // =========================
      if (signal.type === "BUY" && !activeTrade) {
        activeTrade = {
          entryDate: signal.date,
          entryPrice: signal.price,

          highestPrice: signal.price,

          status: "OPEN",
        };
      }

      // =========================
      // TRACK MAX PROFIT
      // =========================
      if (activeTrade) {
        const currentPrice = signal.price;

        if (currentPrice > activeTrade.highestPrice) {
          activeTrade.highestPrice = currentPrice;
        }
      }

      // =========================
      // SELL EXIT
      // =========================
      if (signal.type === "SELL" && activeTrade) {
        const exitPrice = signal.price;

        const pnl =
          ((exitPrice - activeTrade.entryPrice) / activeTrade.entryPrice) * 100;

        const maxProfit =
          ((activeTrade.highestPrice - activeTrade.entryPrice) /
            activeTrade.entryPrice) *
          100;

        trades.push({
          ...activeTrade,

          exitDate: signal.date,
          exitPrice,

          pnl: pnl.toFixed(2),
          maxProfit: maxProfit.toFixed(2),

          status: "CLOSED",
        });

        activeTrade = null;
      }
    }

    return trades;
  };
  const loadChartData = async () => {
    try {
      if (!securityId) return;

      console.log("🔄 Refreshing Live Chart Data");

      setLoadingSecurity(true);

      const tasks = [
        { key: "indicators", fn: fetchIndicators },

        { key: "prevClose", fn: getPrevClose },

        { key: "quote", fn: getMarketQuote },

        { key: "intraday", fn: getMarketIntraday },

        { key: "returns", fn: getReturnData },

        { key: "sma", fn: getSma },
      ];

      const results = await Promise.allSettled(
        tasks.map((t) => {
          if (t.key === "quote") {
            return t.fn({
              securityId: Number(securityId),
              symbol: companyCode,
              userID,
            });
          }

          return t.fn(securityId);
        }),
      );

      const resultMap = {};

      results.forEach((res, idx) => {
        resultMap[tasks[idx].key] = res;
      });

      const quoteResult = resultMap.quote;

      // ❌ quote failed
      if (quoteResult.status === "rejected") {
        const err = quoteResult.reason;

        console.error("Quote Failed", err);

        setError(err?.response?.data?.message || "Failed to load market data");

        setLoadingSecurity(false);

        return;
      }

      const value = quoteResult.value;

      // ❌ no market data
      const hasMarketData = value?.data && Object.keys(value.data).length > 0;

      if (!hasMarketData) {
        setError("Market data unavailable for this stock");

        setLoadingSecurity(false);

        return;
      }

      // 🟡 optional failures
      Object.entries(resultMap).forEach(([key, res]) => {
        if (res.status === "rejected") {
          console.warn(`⚠️ ${key} API failed`);
        }
      });

      // ✅ success
      setError(null);

      setLastUpdated(formatTimestamp());

      setLiveReady(true);

      console.log("✅ Chart Refreshed");
    } catch (err) {
      console.error("❌ Chart Refresh Error", err);

      setError("Unexpected market error");
    } finally {
      setLoadingSecurity(false);
    }
  };
  // console.log("Seucurty id from db", security_id_db);
  useEffect(() => {
    // const loadLiveData = async () => {
    //   setLoadingSecurity(true);
    //   setLiveReady(false);
    //   setError(null);

    //   const tasks = [
    //     { key: "indicators", fn: fetchIndicators },
    //     { key: "prevClose", fn: getPrevClose },
    //     { key: "quote", fn: getMarketQuote }, // 🔴 REQUIRED
    //     { key: "intraday", fn: getMarketIntraday },
    //     { key: "returns", fn: getReturnData },
    //     { key: "sma", fn: getSma },
    //   ];

    //   // const results = await Promise.allSettled(
    //   //   tasks.map((t) => t.fn(securityId)),
    //   // );
    //   const results = await Promise.allSettled(
    //     tasks.map((t) => {
    //       if (t.key === "quote") {
    //         return t.fn({
    //           // securityId,
    //           // securityId: security_id_db,
    //           securityId: Number(security_id_db),
    //           symbol: companyCode,
    //           userID,
    //         });
    //       }

    //       // return t.fn(securityId);
    //       return t.fn(security_id_db);
    //     }),
    //   );

    //   const resultMap = {};
    //   results.forEach((res, idx) => {
    //     resultMap[tasks[idx].key] = res;
    //   });

    //   // 🔴 HARD CHECK: quote must succeed
    //   // if (resultMap.quote.status !== "fulfilled") {
    //   //   console.error("❌ Quote API failed", resultMap.quote.reason);
    //   //   setError("Failed to load live market price");
    //   //   setLiveReady(false);
    //   //   return;
    //   // }
    //   // const quoteResult = resultMap.quote;

    //   // ❌ CASE: REJECTED (network / server error)
    //   // if (quoteResult.status === "rejected") {
    //   //   console.error("❌ Quote rejected:", quoteResult.reason);

    //   //   if (quoteResult.reason?.response?.status === 403) {
    //   //     setShowUpgradeModal(true);
    //   //     setLiveReady(true); // ✅ STOP loader
    //   //     setError(null); // ✅ remove error
    //   //     return;
    //   //   }
    //   //   console.log("❌ NORMAL ERROR");

    //   //   setError("Failed to load live market price");
    //   //   setLiveReady(false);
    //   //   return;

    //   // }
    //   // const quoteResult = resultMap.quote;

    //   // ❌ ONLY handle rejected
    //   // if (quoteResult.status === "rejected") {
    //   //   const err = quoteResult.reason;

    //   //   const type = err?.response?.data?.type;

    //   //   if (type === "TRIAL_LIMIT") {
    //   //     console.log("🔥 TRIAL LIMIT");

    //   //     setShowUpgradeModal(true);
    //   //     setLiveReady(true);
    //   //     setError(null);
    //   //     return;
    //   //   }

    //   //   setError(err?.response?.data?.message || "Failed to load market data");
    //   //   setLiveReady(false);
    //   //   return;
    //   // }
    //   // const quoteResult = resultMap.quote;

    //   // ❌ CASE 1: REJECTED (network / axios error)
    //   // if (quoteResult.status === "rejected") {
    //   //   const err = quoteResult.reason;
    //   //   const type = err?.response?.data?.type;

    //   //   if (type === "TRIAL_LIMIT") {
    //   //     console.log("🔥 TRIAL LIMIT (REJECTED)");

    //   //     setShowUpgradeModal(true);
    //   //     setLiveReady(true);
    //   //     setError(null);
    //   //     return;
    //   //   }

    //   //   setError(err?.response?.data?.message || "Failed to load market data");
    //   //   setLiveReady(false);
    //   //   return;
    //   // }

    //   // ✅ CASE 2: FULFILLED (VERY IMPORTANT)
    //   // const value = quoteResult.value;

    //   // 🔥 HANDLE TRIAL HERE ALSO
    //   // if (value?.type === "TRIAL_LIMIT") {
    //   //   console.log("🔥 TRIAL LIMIT (FULFILLED)");

    //   //   setShowUpgradeModal(true);
    //   //   setLiveReady(true);
    //   //   setError(null);
    //   //   return;
    //   // }

    //   // ✅ NORMAL SUCCESS
    //   // if (!value?.data) {
    //   //   setError("Invalid market data");
    //   //   setLiveReady(false);
    //   //   return;
    //   // }

    //   ///new code

    //   const quoteResult = resultMap.quote;

    //   // =========================
    //   // 🔴 HANDLE REJECTED FIRST
    //   // =========================
    //   if (quoteResult.status === "rejected") {
    //     const err = quoteResult.reason;
    //     const type = err?.response?.data?.type;

    //     if (type === "TRIAL_LIMIT") {
    //       console.log("🔥 TRIAL LIMIT (REJECTED)");

    //       setShowUpgradeModal(true);
    //       setLiveReady(true);
    //       setError(null);
    //       return;
    //     }

    //     console.error("❌ Quote error:", err);

    //     setError(err?.response?.data?.message || "Failed to load market data");
    //     setLiveReady(false);
    //     return;
    //   }

    //   // =========================
    //   // 🟢 HANDLE SUCCESS
    //   // =========================
    //   const value = quoteResult.value;

    //   // 🔥 TRIAL (in case backend sends 200)
    //   if (value?.type === "TRIAL_LIMIT") {
    //     console.log("🔥 TRIAL LIMIT (FULFILLED)");

    //     setShowUpgradeModal(true);
    //     setLiveReady(true);
    //     setError(null);
    //     return;
    //   }

    //   // 🔥 VALIDATE REAL DATA (FIXED)
    //   // if (!value?.data?.NSE_EQ) {
    //   //   console.log("❌ Invalid structure:", value);
    //   //   setError("Invalid market data");
    //   //   setLiveReady(false);
    //   //   return;
    //   // }
    //   // if (!value?.data || Object.keys(value.data).length === 0) {
    //   //   setError("Market data unavailable for this stock");
    //   //   return;
    //   // }
    //   const hasMarketData = value?.data && Object.keys(value.data).length > 0;

    //   if (!hasMarketData) {
    //     setError("Market data unavailable for this stock");
    //     setLiveReady(false);
    //     setLoadingSecurity(false);
    //     return;
    //   }
    //   // ✅ SUCCESS CASE
    //   // const value = quoteResult.value;

    //   // ❌ REMOVE THIS (IMPORTANT)
    //   // if (!value?.success) ❌

    //   // ✅ OPTIONAL VALIDATION (BETTER)
    //   // if (!value?.data) {
    //   //   setError("Invalid market data");
    //   //   setLiveReady(false);
    //   //   return;
    //   // }

    //   // if (quoteResult.status === "fulfilled") {
    //   //   const value = quoteResult.value;

    //   //   if (value?.type === "TRIAL_LIMIT") {
    //   //     console.log("🔥 TRIAL LIMIT TRIGGERED");
    //   //     setShowUpgradeModal(true);
    //   //     setLiveReady(true); // ✅ STOP loader
    //   //     setError(null); // ✅ remove error
    //   //     return;
    //   //   }

    //   //   if (!value?.success) {
    //   //     setError(value?.message || "Something went wrong");
    //   //     return;
    //   //   }
    //   // }

    //   // 🟡 Log optional failures
    //   Object.entries(resultMap).forEach(([key, res]) => {
    //     if (res.status === "rejected") {
    //       console.warn(`⚠️ ${key} API failed`);
    //     }
    //   });

    //   setError(null);
    //   setLoadingSecurity(false);
    //   setLastUpdated(formatTimestamp());

    //   setLiveReady(true);
    // };

    if (!securityId) {
      return;
    }

    const loadLiveData = async () => {
      try {
        setLoadingSecurity(true);

        setLiveReady(false);

        setError(null);

        const tasks = [
          { key: "indicators", fn: fetchIndicators },
          { key: "prevClose", fn: getPrevClose },
          { key: "quote", fn: getMarketQuote },
          { key: "intraday", fn: getMarketIntraday },
          { key: "returns", fn: getReturnData },
          { key: "sma", fn: getSma },
        ];

        const results = await Promise.allSettled(
          tasks.map((t) => {
            if (t.key === "quote") {
              return t.fn({
                securityId: Number(securityId),
                symbol: companyCode,
                userID,
              });
            }

            return t.fn(securityId);
          }),
        );

        const resultMap = {};

        results.forEach((res, idx) => {
          resultMap[tasks[idx].key] = res;
        });

        const quoteResult = resultMap.quote;

        if (quoteResult.status === "rejected") {
          const err = quoteResult.reason;

          const type = err?.response?.data?.type;

          if (type === "TRIAL_LIMIT") {
            setShowUpgradeModal(true);

            setLiveReady(true);

            setLoadingSecurity(false);

            setError(null);

            return;
          }

          setError(
            err?.response?.data?.message || "Failed to load market data",
          );

          setLiveReady(false);

          setLoadingSecurity(false);

          return;
        }

        const value = quoteResult.value;

        // 🔥 fulfilled trial limit
        if (value?.type === "TRIAL_LIMIT") {
          setShowUpgradeModal(true);

          setLiveReady(true);

          setLoadingSecurity(false);

          setError(null);

          return;
        }

        // const hasMarketData = quoteData;
        const hasMarketData = value?.data && Object.keys(value.data).length > 0;
        // const hasMarketData = value?.data && Object.keys(value.data).length > 0;

        if (!hasMarketData) {
          setError("Market data unavailable for this stock");

          setLiveReady(false);

          setLoadingSecurity(false);

          return;
        }

        // 🟡 optional failures
        Object.entries(resultMap).forEach(([key, res]) => {
          if (res.status === "rejected") {
            console.warn(`⚠️ ${key} API failed`);
          }
        });

        // ✅ success
        setError(null);

        setLoadingSecurity(false);

        setLastUpdated(formatTimestamp());

        setLiveReady(true);
      } catch (err) {
        console.error("Live Data Crash", err);

        setError("Unexpected market error");

        setLoadingSecurity(false);

        setLiveReady(false);
      }
    };
    loadLiveData();
  }, [securityId]);

  //previous working code
  // useEffect(() => {
  //   if (!loadingSecurity) return;

  //   const timer = setTimeout(() => {
  //     if (!securityId) {
  //       setError("❌ Market data not found for this stock");
  //       setLoadingSecurity(false);
  //     }
  //   }, 6000);

  //   return () => clearTimeout(timer);
  // }, [loadingSecurity, securityId]);

  // useEffect(() => {
  //   if (securityId) {
  //     setLoadingSecurity(false);
  //   }
  // }, [securityId]);
  // useEffect(() => {
  //   if (!loadingSecurity) return;

  //   const timer = setTimeout(() => {
  //     const hasQuote = quoteData?.[security_id_db];

  //     console.log("Has quote:", hasQuote);

  //     if (!hasQuote) {
  //       setError("❌ Market data not found for this stock");
  //       setLoadingSecurity(false);
  //     }
  //   }, 6000);

  //   return () => clearTimeout(timer);
  // }, [loadingSecurity, security_id_db, quoteData]);
  console.log("Error message", error);

  useEffect(() => {
    if (!companyCode) return;

    setError(null);
    resetTargetPrice();
    resetMarketData();

    setLiveReady(false);

    setLoadingSecurity(true);

    getNameBySymbol(companyCode);

    getMarketCap(companyCode);
    fetchBySymbol(companyCode);

    getTargetPrice(companyCode, market);

    getStockStatistics(companyCode);

    // ✅ OLD WORKING FLOW
    loadSingleStock();
  }, [companyCode]);
  console.log("Target Price", targetPrice);
  console.log("Face Value", marketCapData);
  // const rawPrice = targetPrice?.data?.target_price;
  // const target_price = rawPrice ? Number(rawPrice?.replace(/,/g, "")) : 0;
  // const rawLowPrice = targetPrice?.data?.target_low;
  // const target_low = rawLowPrice ? Number(rawLowPrice?.replace(/,/g, "")) : 0;
  // const rawHighPrice = targetPrice?.data?.target_high;
  // const target_high = rawHighPrice
  //   ? Number(rawHighPrice?.replace(/,/g, ""))
  //   : 0;
  const rawPrice = targetPrice?.data?.target_price;
  const target_price = rawPrice
    ? Number(String(rawPrice).replace(/,/g, ""))
    : 0;

  const rawLowPrice = targetPrice?.data?.target_low;
  const target_low = rawLowPrice
    ? Number(String(rawLowPrice).replace(/,/g, ""))
    : 0;

  const rawHighPrice = targetPrice?.data?.target_high;
  const target_high = rawHighPrice
    ? Number(String(rawHighPrice).replace(/,/g, ""))
    : 0;

  console.log("Target Price", target_price);
  const projectChange =
    target_price &&
    (((target_price - quote?.last_price) / quote?.last_price) * 100).toFixed(2);
  console.log("ProjectedChange", projectChange);
  console.log("Stats data", statsData);
  const peRatio = statsData?.data?.body?.forwardPE.fmt;
  console.log("PE ratio is:-", peRatio);
  console.log("Return dta", returnData);
  //return calculator
  const calcReturn = (current, past) =>
    past ? (((current - past) / past) * 100).toFixed(2) : null;
  const oneWeekReturn = calcReturn(
    quote?.last_price,
    returnData?.prices?.oneWeek,
  );
  const oneMonthReturn = calcReturn(
    quote?.last_price,
    returnData?.prices?.oneMonth,
  );
  const ytdReturn = calcReturn(quote?.last_price, returnData?.prices?.ytd);
  const oneYearReturn = calcReturn(
    quote?.last_price,
    returnData?.prices?.oneYear,
  );
  const threeYearReturn = calcReturn(
    quote?.last_price,
    returnData?.prices?.threeYear,
  );
  const fiveYearReturn = calcReturn(
    quote?.last_price,
    returnData?.prices?.fiveYear,
  );
  console.log(
    "OneWeekReturn, oneMonth, Ytd, onYear,threeYear,fiveYear",
    oneWeekReturn,
    oneMonthReturn,
    ytdReturn,
    oneYearReturn,
    threeYearReturn,
    fiveYearReturn,
  );

  const tLow = Number(target_low);
  const tHigh = Number(target_high);
  const tMean = Number(target_price);
  const ltp = Number(quote?.last_price);

  let targetPosition = 50;
  let ltpPosition = 50;

  if (tLow && tHigh && tHigh > tLow && ltp) {
    // 1️⃣ Base range = target range
    let minVal = tLow;
    let maxVal = tHigh;

    // 2️⃣ Expand range if LTP goes beyond
    if (ltp < minVal) minVal = ltp;
    if (ltp > maxVal) maxVal = ltp;

    // 3️⃣ Add padding (10% of visible range)
    const range = maxVal - minVal;
    const padding = range * 0.15 || 1;

    const axisMin = minVal - padding;
    const axisMax = maxVal + padding;

    // 4️⃣ Normalize to %
    const toPercent = (value) =>
      ((value - axisMin) / (axisMax - axisMin)) * 100;

    // 5️⃣ Clamp so nothing escapes UI
    const clamp = (v) => Math.max(0, Math.min(100, v));

    targetPosition = clamp(toPercent(tMean));
    ltpPosition = clamp(toPercent(ltp));
  }

  const statisticsData = statsData?.data?.body;
  console.log("stockName", stockName);
  // const getPaddedPosition = (low, high, value) => {
  //   if (
  //     !Number.isFinite(low) ||
  //     !Number.isFinite(high) ||
  //     !Number.isFinite(value) ||
  //     high <= low
  //   ) {
  //     return 50; // safe center
  //   }

  //   // Base range
  //   let minVal = low;
  //   let maxVal = high;

  //   // Expand if value breaks range
  //   if (value < minVal) minVal = value;
  //   if (value > maxVal) maxVal = value;

  //   // Add padding (10%)
  //   const range = maxVal - minVal;
  //   const padding = range * 0.1 || 1;

  //   const axisMin = minVal - padding;
  //   const axisMax = maxVal + padding;

  //   const percent = ((value - axisMin) / (axisMax - axisMin)) * 100;

  //   // Clamp to UI
  //   return Math.max(0, Math.min(100, percent));
  // };
  // const dayLtpPosition = getPaddedPosition(
  //   stock?.low,
  //   stock?.high,
  //   quote?.last_price,
  // );

  // const weekLtpPosition = getPaddedPosition(
  //   weekLow,
  //   weekHigh,
  //   quote?.last_price,
  // );
  const tempLtp = 1778;
  // const dayLtpPosition = getPaddedPosition(stock?.low, stock?.high, tempLtp);
  const getPaddedPosition = (low, high, value) => {
    if (
      !Number.isFinite(low) ||
      !Number.isFinite(high) ||
      !Number.isFinite(value) ||
      high <= low
    ) {
      return 50;
    }

    // 🔥 BASE RANGE (DO NOT CHANGE LOW / HIGH)
    const baseMin = low;
    const baseMax = high;

    // 🔥 Expand ONLY if value breaks range
    const visibleMin = Math.min(baseMin, value);
    const visibleMax = Math.max(baseMax, value);

    const range = visibleMax - visibleMin || 1;

    // ✅ Small controlled padding (8%)
    const padding = range * 0.08;

    const axisMin = visibleMin - padding;
    const axisMax = visibleMax + padding;

    // 🔒 Normalize
    const percent = ((value - axisMin) / (axisMax - axisMin)) * 100;

    // 🔒 Clamp (never overflow UI)
    return Math.max(0, Math.min(100, percent));
  };

  // const getSafePositionWithPadding = (low, high, value) => {
  //   if (
  //     !Number.isFinite(low) ||
  //     !Number.isFinite(high) ||
  //     !Number.isFinite(value) ||
  //     high <= low
  //   ) {
  //     return 50;
  //   }

  //   const PADDING_PERCENT = 10; // 👈 fixed visual padding

  //   // Clamp value to range
  //   const clampedValue = Math.min(Math.max(value, low), high);

  //   const usableRange = 100 - PADDING_PERCENT * 2;

  //   const relative = (clampedValue - low) / (high - low);

  //   return PADDING_PERCENT + relative * usableRange;
  // };

  // const dayLtpPosition = getPaddedPosition(stock?.low, stock?.high, tempLtp);
  const getSafeLtpPosition = (low, high, value) => {
    if (
      !Number.isFinite(low) ||
      !Number.isFinite(high) ||
      !Number.isFinite(value) ||
      high <= low
    ) {
      return 50;
    }

    const PADDING = 10; // % visual padding on both sides
    const usable = 100 - PADDING * 2;

    const clamped = Math.min(Math.max(value, low), high);
    const ratio = (clamped - low) / (high - low);

    return PADDING + ratio * usable;
  };

  const formatMarketCapINR = (value) => {
    if (!value) return "--";

    if (value >= 1e7) {
      return `₹${(value / 1e7).toFixed(2)} Cr`;
    }

    if (value >= 1e5) {
      return `₹${(value / 1e5).toFixed(2)} L`;
    }

    return `₹${value.toLocaleString("en-IN")}`;
  };

  const getDynamicScalePositions = (low, high, ltp) => {
    if (
      !Number.isFinite(low) ||
      !Number.isFinite(high) ||
      !Number.isFinite(ltp)
    ) {
      return { lowPos: 30, ltpPos: 50, highPos: 70 };
    }

    const minVal = Math.min(low, ltp);
    const maxVal = Math.max(high, ltp);

    const range = maxVal - minVal || 1;
    const padding = range * 0.15; // 15% breathing space

    const axisMin = minVal - padding;
    const axisMax = maxVal + padding;

    const toPercent = (v) => ((v - axisMin) / (axisMax - axisMin)) * 100;

    return {
      lowPos: toPercent(low),
      ltpPos: toPercent(ltp),
      highPos: toPercent(high),
    };
  };

  // const dayLtpPosition = getDynamicScalePositions(
  //   stock?.low,
  //   stock?.high,
  //   tempLtp,
  // );
  const {
    lowPos: dayLowPos,
    ltpPos: dayLtpPos,
    highPos: dayHighPos,
  } = getDynamicScalePositions(stock?.low, stock?.high, tempLtp);
  const computeDayRangeScale = (low, high, ltp) => {
    if (
      !Number.isFinite(low) ||
      !Number.isFinite(high) ||
      !Number.isFinite(ltp)
    ) {
      return null;
    }

    // 🔥 true visible bounds
    const minVal = Math.min(low, ltp);
    const maxVal = Math.max(high, ltp);

    const range = maxVal - minVal || 1;
    const padding = range * 0.1; // 10% padding

    const axisMin = minVal - padding;
    const axisMax = maxVal + padding;

    const toPercent = (v) => ((v - axisMin) / (axisMax - axisMin)) * 100;

    return {
      axisMin,
      axisMax,
      lowPos: toPercent(low),
      highPos: toPercent(high),
      ltpPos: toPercent(ltp),
    };
  };
  const dayScale = computeDayRangeScale(stock?.low, stock?.high, tempLtp);

  // if (!dayScale) return null;

  // const { lowPos, highPos, ltpPos } = dayScale;

  const weekLtpPosition = getPaddedPosition(
    weekLow,
    weekHigh,
    quote?.last_price,
  );
  const stockAISummaryPayload = {
    symbol: companyCode,
    companyName: stockName?.company,

    price: {
      ltp: quote?.last_price,
      open: stock?.open,
      close: prev_close,
      high: stock?.high,
      low: stock?.low,
      percentChange: percent_change,
    },

    forecast: {
      targetPrice: target_price,
      targetLow: target_low,
      targetHigh: target_high,
      upsidePercent: projectChange,
    },

    technicals: {
      rsi: latestRSIValue,
      macd: latestMACDValue,
      pcr: pcr?.value,
    },

    fundamentals: {
      peRatio,
      faceValue: marketCapData?.faceValue,
      marketCap: marketCapData?.marketCap,
    },

    returns: {
      oneWeek: oneWeekReturn,
      oneMonth: oneMonthReturn,
      ytd: ytdReturn,
      oneYear: oneYearReturn,
      threeYear: threeYearReturn,
      fiveYear: fiveYearReturn,
    },

    meta: {
      timeframe: timeFrame,
      lastUpdated,
    },
  };
  console.log("Stock Prompt data", stockAISummaryPayload);
  console.log("Sma Data and avaialbleCandles", maData, availableCandles);

  //get trend for sma
  const getTrend = (ltp, maValue) => (ltp >= maValue ? "Buy" : "Sell");
  //rows for sma
  // const rows = maData.map((ma) => ({
  //   name: ma.name,
  //   smaTrend: getTrend(ltp, ma.sma),
  //   emaTrend: getTrend(ltp, ma.ema),
  // }));

  // const summary = {
  //   buy: rows.filter((r) => r.smaTrend === "Buy" && r.emaTrend === "Buy")
  //     .length,

  //   sell: rows.filter((r) => r.smaTrend === "Sell" && r.emaTrend === "Sell")
  //     .length,

  //   neutral: rows.length - rows.filter((r) => r.smaTrend === r.emaTrend).length,
  // };

  // const buildMARows = (ltp, maData) =>
  //   maData?.map((ma) => {
  //     const smaTrend = ltp >= ma.sma ? "Buy" : "Sell";
  //     const emaTrend = ltp >= ma.ema ? "Buy" : "Sell";

  //     return {
  //       name: ma.name,
  //       smaValue: ma.sma,
  //       emaValue: ma.ema,
  //       smaTrend,
  //       emaTrend,
  //     };
  //   });

  const buildMARows = (ltp, maData = []) => {
    if (!ltp || !Array.isArray(maData)) {
      return [];
    }

    return maData.map((ma) => {
      const smaTrend = ltp >= ma?.sma ? "Buy" : "Sell";

      const emaTrend = ltp >= ma?.ema ? "Buy" : "Sell";

      return {
        name: ma?.name || "-",

        smaValue: Number(ma?.sma || 0),

        emaValue: Number(ma?.ema || 0),

        smaTrend,

        emaTrend,
      };
    });
  };
  const buildMASummary = (rows) => {
    const buy1 = rows?.filter((r) => r?.smaTrend === "Buy").length;
    const buy2 = rows?.filter((r) => r?.emaTrend === "Buy").length;
    const finalBuy = buy1 + buy2;
    const sell = rows.filter(
      (r) => r.smaTrend === "Sell" || r.emaTrend === "Sell",
    ).length;
    const sell1 = rows?.filter((r) => r?.smaTrend === "Sell").length;
    const sell2 = rows?.filter((r) => r?.emaTrend === "Sell").length;
    const finalSell = sell1 + sell2;

    return { finalBuy, finalSell };
  };

  // const rows = buildMARows(ltp, maData);
  const rows = useMemo(() => {
    if (!ltp || !maData?.length) {
      return [];
    }

    return buildMARows(ltp, maData);
  }, [ltp, maData]);
  console.log("Rows data", rows);
  const summary = buildMASummary(rows);
  console.log("Summary", summary);

  function calculateGaugeValue(buy, sell) {
    const total = buy + sell;
    if (total === 0) return 0;
    return (buy - sell) / total; // -1 → +1
  }

  function getGaugeLabel(value) {
    if (value <= -0.6) return "Strong Sell";
    if (value <= -0.2) return "Sell";
    if (value < 0.2) return "Neutral";
    if (value < 0.6) return "Buy";
    return "Strong Buy";
  }

  //testing r1,r2,r3 and s1,s2,s3
  const [prevLow, prevHigh, prevClose, prevOpen] = [
    2937.5, 2977, 2948.2, 2959.1,
  ];

  const pivot = (prevLow + prevHigh, prevClose) / 3;
  const r1 = 2 * pivot - prevLow;
  const r2 = pivot + (prevHigh - prevClose);
  const r3 = prevHigh + 2 * (pivot - prevLow);
  console.log("R1,R2,R3", r1, r2, r3);

  //   Open
  //    2959.1,

  // Close
  //       2948.2,

  // Low
  //  2937.5,

  // High
  //   2977,

  const resistData = previousClose?.hist;
  console.log("Resistnce data", resistData);
  const resistLow = resistData?.low;
  const resistHigh = resistData?.high;
  const resistClose = resistData?.close;
  const resistOpen = resistData?.open;
  const resDailyLow = resistLow?.[resistLow?.length - 1];
  const resWeeklyLow = resistLow?.[0];
  const resDailyHigh = resistHigh?.[resistHigh?.length - 1];
  const resWeeklyHigh = resistHigh?.[0];
  const resDailyClose = resistClose?.[resistClose?.length - 1];
  const resWeeklyClose = resistClose?.[0];
  const resDailyOpen = resistOpen?.[resistOpen?.length - 1];
  const resWeeklyOpen = resistOpen?.[0];
  const calculatePivots = (open, high, low, close) => {
    const range = high - low;

    // Classic
    const classicP = (high + low + close) / 3;
    const classic = {
      R3: high + 2 * (classicP - low),
      R2: classicP + range,
      R1: 2 * classicP - low,
      P: classicP,

      S1: 2 * classicP - high,
      S2: classicP - range,
      S3: low - 2 * (high - classicP),
    };

    // Fibonacci
    const fib = {
      R1: classicP + range * 0.382,
      R2: classicP + range * 0.618,
      R3: classicP + range * 1.0,
      P: classicP,
      S1: classicP - range * 0.382,
      S2: classicP - range * 0.618,
      S3: classicP - range * 1.0,
    };

    // Camarilla
    const cam = {
      R1: close + range * 1.0833,
      R2: close + range * 1.1666,
      R3: close + range * 1.25,
      P: close,
      S1: close - range * 1.0833,
      S2: close - range * 1.1666,
      S3: close - range * 1.25,
    };

    // Woodie
    const woodieP = (high + low + 2 * close) / 4;
    const woodie = {
      R1: 2 * woodieP - low,
      R2: woodieP + range,
      R3: high + 2 * (woodieP - low),
      P: woodieP,
      S1: 2 * woodieP - high,
      S2: woodieP - range,
      S3: low - 2 * (high - woodieP),
    };

    // Demark
    let demPivot;
    if (close < open) {
      demPivot = (high + 2 * low + close) / 4;
    } else if (close > open) {
      demPivot = (2 * high + low + close) / 4;
    } else {
      demPivot = (high + low + 2 * close) / 4;
    }
    const demark = {
      P: demPivot,
      R1: demPivot + range,
      S1: demPivot - range,
    };

    return { classic, fib, cam, woodie, demark };
  };

  const resWeekly = calculatePivots(
    resWeeklyOpen,
    resWeeklyHigh,
    resWeeklyLow,
    resWeeklyClose,
  );
  const resDaily = calculatePivots(
    resDailyOpen,
    resDailyHigh,
    resDailyLow,
    resDailyClose,
  );
  console.log("ResWeekly", resWeekly);
  console.log("ResDaily", resDaily);
  // const levels = [
  //   "R1", "R2", "R3", "P", "S1", "S2", "S3"];
  const levels = [
    { key: "R3", label: "Third Resistance" },
    { key: "R2", label: "Second Resistance" },
    { key: "R1", label: "First Resistance" },
    { key: "P", label: "Pivot" },
    { key: "S1", label: "First Support" },
    { key: "S2", label: " Second Support" },
    { key: "S3", label: " Third Support" },
  ];
  const resistanceDataToRender =
    resistTimeFrame === "day" ? resDaily : resWeekly;

  //min dropdown for chart
  const resampleMinuteMACD = (data, step) => {
    if (!Array.isArray(data) || step === 1) return data;

    const result = [];

    for (let i = 0; i < data.length; i += step) {
      const chunk = data.slice(i, i + step);
      if (chunk.length < step) continue;

      const last = chunk[chunk.length - 1];

      result.push({
        date: last.date, // last candle time
        MACD: last.MACD,
        signal: last.signal,
        histogram: chunk.reduce((sum, c) => sum + (c.histogram ?? 0), 0),
      });
    }

    return result;
  };

  //day dropdown
  const resampleDailyMACD = (data, interval) => {
    if (!Array.isArray(data) || interval === "1d") return data;

    const groups = new Map();

    data.forEach((row) => {
      const d = new Date(row.date);
      if (isNaN(d.getTime())) return;

      let key;

      // 📅 WEEKLY
      if (interval === "1w") {
        const year = d.getFullYear();
        const week = Math.ceil(
          ((d - new Date(year, 0, 1)) / 86400000 +
            new Date(year, 0, 1).getDay() +
            1) /
            7,
        );
        key = `${year}-W${week}`;
      }

      // 📅 MONTHLY
      if (interval === "1mo") {
        key = `${d.getFullYear()}-${d.getMonth() + 1}`;
      }

      // 📅 3 MONTHS
      if (interval === "3mo") {
        const quarter = Math.floor(d.getMonth() / 3) + 1;
        key = `${d.getFullYear()}-Q${quarter}`;
      }

      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(row);
    });

    return Array.from(groups.values()).map((group) => {
      const last = group[group.length - 1];

      return {
        date: last.date, // last trading day
        MACD: last.MACD,
        signal: last.signal,
        histogram: group.reduce((sum, g) => sum + (g.histogram ?? 0), 0),
      };
    });
  };

  const selectedData = (() => {
    // ⏱ INTRADAY
    if (timeFrame === "min") {
      if (!Array.isArray(macdChartDataMin)) return [];

      if (interval === "1m") return macdChartDataMin;
      if (interval === "3m") return resampleMinuteMACD(macdChartDataMin, 3);
      if (interval === "5m") return resampleMinuteMACD(macdChartDataMin, 5);

      return macdChartDataMin; // safe fallback
    }

    // 📅 DAILY / HIGHER
    if (!Array.isArray(macdChartData)) return [];

    if (interval === "1d") return macdChartData;
    if (interval === "1w") return resampleDailyMACD(macdChartData, "1w");
    if (interval === "1mo") return resampleDailyMACD(macdChartData, "1mo");
    if (interval === "3mo") return resampleDailyMACD(macdChartData, "3mo");

    return macdChartData; // safe fallback
  })();

  const intradayXAxis =
    intradayData?.indicators?.dates?.map((d) => {
      if (!d) return null;

      // "24/2/2026, 12:35:00 pm"
      const safe = d.replace(",", "");
      const dateObj = new Date(safe);

      return isNaN(dateObj.getTime()) ? null : dateObj.getTime(); // 🔥 epoch ms
    }) || [];
  // const priceChartDataDay = indicatorData?.closeSeries || [];
  // const priceChartDataMin = intradayData?.closeSeries || [];
  const minPriceBase = intradayData?.closeSeries || [];
  const dayPriceBase = indicatorData?.closeSeries || [];
  const resampleMinutePrice = (data, step) => {
    if (!Array.isArray(data) || step === 1) return data;

    const result = [];
    for (let i = 0; i < data.length; i += step) {
      const chunk = data.slice(i, i + step);
      if (chunk.length < step) continue;

      const last = chunk[chunk.length - 1];
      result.push({
        date: last.date,
        close: last.close,
      });
    }
    return result;
  };

  const resampleDailyPrice = (data, interval) => {
    if (!Array.isArray(data) || interval === "1d") return data;

    const groups = new Map();

    data.forEach((row) => {
      const d = new Date(row.date);
      if (isNaN(d.getTime())) return;

      let key;

      if (interval === "1w") {
        const year = d.getFullYear();
        const week = Math.ceil(
          ((d - new Date(year, 0, 1)) / 86400000 +
            new Date(year, 0, 1).getDay() +
            1) /
            7,
        );
        key = `${year}-W${week}`;
      }

      if (interval === "1mo") {
        key = `${d.getFullYear()}-${d.getMonth() + 1}`;
      }

      if (interval === "3mo") {
        const q = Math.floor(d.getMonth() / 3) + 1;
        key = `${d.getFullYear()}-Q${q}`;
      }

      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(row);
    });

    return Array.from(groups.values()).map((group) => {
      const last = group[group.length - 1];
      return {
        date: last.date,
        close: last.close,
      };
    });
  };
  const selectedPriceData = useMemo(() => {
    if (timeFrame === "min") {
      const stepMap = { "1m": 1, "3m": 3, "5m": 5 };
      return resampleMinutePrice(minPriceBase, stepMap[interval] || 1);
    }

    return resampleDailyPrice(dayPriceBase, interval);
  }, [timeFrame, interval, minPriceBase, dayPriceBase]);
  // useEffect(() => {

  //   if (!selectedData?.length || !selectedPriceData?.length) return;

  //   const signals = detectCrossovers(selectedData, selectedPriceData);

  //   setCrossovers(prev => {

  //     // prevent infinite re-renders
  //     if (JSON.stringify(prev) === JSON.stringify(signals)) {
  //       return prev;
  //     }

  //     return signals;

  //   });

  // }, [selectedData, selectedPriceData]);
  useEffect(() => {
    if (!macdChartDataMin?.length || !minPriceBase?.length) return;

    const signals = detectCrossovers(macdChartDataMin, minPriceBase);

    setCrossovers((prev) => {
      if (JSON.stringify(prev) === JSON.stringify(signals)) {
        return prev;
      }

      return signals;
    });
  }, [macdChartDataMin, minPriceBase]);

  //previous code
  // const buildPDFPayload = () => {
  //   return {
  //     symbol: companyCode,
  //     companyName: stockName?.company,

  //     price: {
  //       ltp: quote?.last_price,
  //       open: stock?.open,
  //       high: stock?.high,
  //       low: stock?.low,
  //       close: prev_close,
  //       percentChange: Number(percent_change),
  //     },

  //     forecast: {
  //       targetPrice: target_price,
  //       upsidePercent: Number(projectChange),
  //     },

  //     technicals: {
  //       rsi: latestRSIValue,
  //       macd: latestMACDValue,
  //       pcr: pcr?.value,
  //     },

  //     fundamentals: {
  //       peRatio,
  //       marketCap: marketCapData?.marketCap,
  //       faceValue: marketCapData?.faceValue,
  //     },

  //     returns: {
  //       oneWeek: Number(oneWeekReturn),
  //       oneMonth: Number(oneMonthReturn),
  //       ytd: Number(ytdReturn),
  //       oneYear: Number(oneYearReturn),
  //     },
  //   };
  // };

  const buildPDFPayload = () => {
    return {
      symbol: companyCode,
      companyName: stockName?.company,

      price: {
        ltp: quote?.last_price,
        open: stock?.open,
        high: stock?.high,
        low: stock?.low,
        close: prev_close,
        percentChange: Number(percent_change),
      },

      forecast: {
        targetPrice: target_price,
        upsidePercent: Number(projectChange),
      },

      technicals: {
        rsi: latestRSIValue,
        macd: latestMACDValue,
        pcr: pcr?.value,
      },

      fundamentals: {
        peRatio,
        marketCap: marketCapData?.marketCap,
        faceValue: marketCapData?.faceValue,
      },

      returns: {
        oneWeek: Number(oneWeekReturn),
        oneMonth: Number(oneMonthReturn),
        ytd: Number(ytdReturn),
        oneYear: Number(oneYearReturn),
      },
      vwapAnalysis: {
        vwap: latestVWAP ? Number(latestVWAP.toFixed(2)) : null,
        ltp: ltpValue,

        difference: vwap ? Number((ltpValue - vwap).toFixed(2)) : null,

        percentFromVWAP: vwap
          ? Number((((ltpValue - vwap) / vwap) * 100).toFixed(2))
          : null,

        signal, // Bullish / Bearish / Neutral

        result:
          signal === "Bullish"
            ? "Price trading above VWAP - bullish intraday bias"
            : signal === "Bearish"
              ? "Price trading below VWAP - bearish intraday bias"
              : "Price near VWAP - neutral momentum",
      },

      /* =========================
       ✅ NEW SECTIONS ADDED
    ========================== */

      valuation: {
        marketCap: marketCapData?.marketCap,
        enterpriseValue: statisticsData?.enterpriseValue?.fmt,
        forwardPE: statisticsData?.forwardPE?.fmt,
        priceToBook: statisticsData?.priceToBook?.fmt,
        enterpriseToRevenue: statisticsData?.enterpriseToRevenue?.fmt,
      },

      profitability: {
        profitMargin: statisticsData?.profitMargins?.fmt,
        earningsGrowthQoQ: statisticsData?.earningsQuarterlyGrowth?.fmt,
        trailingEPS: statisticsData?.trailingEps?.fmt,
        forwardEPS: statisticsData?.forwardEps?.fmt,
      },

      ownership: {
        insiderHolding: statisticsData?.heldPercentInsiders?.fmt,
        institutionalHolding: statisticsData?.heldPercentInstitutions?.fmt,
        floatShares: statisticsData?.floatShares?.fmt,
        sharesOutstanding: statisticsData?.sharesOutstanding?.fmt,
      },

      /* =========================
       ✅ PREVIOUS EXTRA FIELDS
    ========================== */

      insight: {
        result: timeFrame === "min" ? result1 : result,
        prediction: timeFrame === "min" ? prediction1 : prediction,
        timeframe: timeFrame,
      },

      signal: {
        rsiSignal:
          latestRSIValue > 60
            ? "Bullish"
            : latestRSIValue < 40
              ? "Bearish"
              : "Neutral",

        macdSignal:
          latestMACDValue > 0
            ? "Bullish"
            : latestMACDValue < 0
              ? "Bearish"
              : "Neutral",
      },

      metadata: {
        generatedAt: new Date().toISOString(),
        generatedAtIST: new Date().toLocaleString("en-IN"),
        source: "Phro Trader",
      },

      abbreviations: [
        { short: "RSI", full: "Relative Strength Index" },
        { short: "MACD", full: "Moving Average Convergence Divergence" },
        { short: "PCR", full: "Put Call Ratio" },
        { short: "P/E", full: "Price to Earnings Ratio" },
        { short: "LTP", full: "Last Traded Price" },
        { short: "YTD", full: "Year To Date" },
        { short: "EPS", full: "Earnings Per Share" },
        { short: "QoQ", full: "Quarter over Quarter" },
      ],
    };
  };

  // const buildPDFPayload = () => {
  //   return {
  //     symbol: companyCode,
  //     companyName: stockName?.company,

  //     /* =========================
  //      PRICE DATA (UPDATED)
  //   ========================= */
  //     price: {
  //       ltp: quote?.last_price,
  //       open: stock?.open,
  //       high: stock?.high,
  //       low: stock?.low,
  //       close: prev_close,
  //       percentChange: Number(percent_change),

  //       // ✅ NEW ADDITIONS
  //       dayHigh: stock?.high,
  //       dayLow: stock?.low,
  //       week52High: weekHigh,
  //       week52Low: weekLow,
  //       volume: quote?.volume,
  //     },

  //     /* =========================
  //      FORECAST (UPDATED)
  //   ========================= */
  //     forecast: {
  //       targetPrice: target_price,
  //       targetLow: target_low, // ✅ NEW
  //       targetHigh: target_high, // ✅ NEW
  //       upsidePercent: Number(projectChange),
  //     },

  //     /* =========================
  //      TECHNICALS
  //   ========================= */
  //     technicals: {
  //       rsi: latestRSIValue,
  //       macd: latestMACDValue,
  //       pcr: pcr?.value,
  //     },

  //     /* =========================
  //      FUNDAMENTALS
  //   ========================= */
  //     fundamentals: {
  //       peRatio,
  //       marketCap: marketCapData?.marketCap,
  //       faceValue: marketCapData?.faceValue,
  //     },

  //     /* =========================
  //      RETURNS
  //   ========================= */
  //     returns: {
  //       oneWeek: Number(oneWeekReturn),
  //       oneMonth: Number(oneMonthReturn),
  //       ytd: Number(ytdReturn),
  //       oneYear: Number(oneYearReturn),
  //     },

  //     /* =========================
  //      MARKET DEPTH (NEW 🔥)
  //   ========================= */
  //     marketDepth: {
  //       buyPercent,
  //       sellPercent,
  //       totalBuyQty,
  //       totalSellQty,
  //     },

  //     /* =========================
  //      META INFO (NEW)
  //   ========================= */
  //     meta: {
  //       generatedAt: new Date().toISOString(),
  //       timeframe: timeFrame,
  //       lastUpdated,
  //     },
  //   };
  // };

  // const handleDownloadReport = () => {
  //   const payload = buildPDFPayload();

  //   downloadStockPDF(payload, companyCode);
  // };
  const handleDownloadReport = async () => {
    try {
      await downloadStockPDF(buildPDFPayload(), companyCode);

      // ✅ SUCCESS ALERT
      window.alert("✅ Report downloaded successfully!");
    } catch (err) {
      // ❌ ERROR ALERT
      window.alert("❌ PDF generation failed");
    }
  };

  //handle add for watchlist
  // const handleAdd = async (symbol) => {
  //   try {
  //     const res = await getSecurityIds([symbol]);
  //     const securityId = res?.[0]?.security_id;

  //     await addToWatchlist({
  //       userID,
  //       symbol,
  //       securityId,
  //     });
  //   } catch (err) {
  //     console.error("Add failed:", err);
  //   }
  // };
  const handleAdd = async (symbol) => {
    // const exists = isInWatchlist(symbol); // ✅ check first
    const exists = watchlist?.some(
      (item) =>
        item.symbol?.trim().toUpperCase() === symbol?.trim().toUpperCase(),
    );

    try {
      if (exists) {
        // 🔥 REMOVE
        await removeFromWatchlist({ userID, symbol });
      } else {
        await addToWatchlist({
          userID,
          symbol,
          securityId,
        });
        console.log("Added symbol");
      }
      // await fetchWatchlist(userID);
    } catch (err) {
      console.error("Toggle failed:", err);
    }
  };

  const intradayVwap = intradayData;
  // const candles = intradayVwap?.close?.map((price, i) => ({
  //   close: price,
  //   volume: intradayVwap?.volume[i],
  // }));

  //previoys candle working
  // const candles = useMemo(() => {
  //   if (!intradayData?.intraday) return [];

  //   const data = intradayData.intraday;

  //   return (
  //     data.close?.map((price, i) => ({
  //       close: price,
  //       volume: data.volume?.[i] || 0,
  //     })) || []
  //   );
  // }, [intradayData]);
  const candles = useMemo(() => {
    const data = intradayData?.intraday;

    if (!data || !Array.isArray(data.close)) {
      return [];
    }

    return data.close.map((price, i) => ({
      close: Number(price) || 0,

      volume: Number(data.volume?.[i]) || 0,
    }));
  }, [intradayData]);

  //vwap function
  // const calculateVWAP = (data) => {
  //   if (!Array.isArray(data) || data.length === 0) return [];

  //   let cumulativePV = 0;
  //   let cumulativeVolume = 0;

  //   return data.map((candle) => {
  //     const price = candle.close;
  //     const volume = candle.volume || 0;

  //     cumulativePV += price * volume;
  //     cumulativeVolume += volume;

  //     const vwap =
  //       cumulativeVolume === 0 ? null : cumulativePV / cumulativeVolume;

  //     return {
  //       ...candle,
  //       vwap,
  //     };
  //   });
  // };
  const calculateVWAP = (data = []) => {
    if (!Array.isArray(data) || data.length === 0) {
      return [];
    }

    let cumulativePV = 0;
    let cumulativeVolume = 0;

    return data.map((candle) => {
      const price = Number(candle?.close) || 0;

      const volume = Number(candle?.volume) || 0;

      cumulativePV += price * volume;

      cumulativeVolume += volume;

      const vwap =
        cumulativeVolume === 0 ? null : cumulativePV / cumulativeVolume;

      return {
        ...candle,
        vwap,
      };
    });
  };

  const vwapData = useMemo(() => {
    if (!Array.isArray(candles)) {
      return [];
    }

    return calculateVWAP(candles);
  }, [candles]);
  const latestVWAP = vwapData?.at(-1)?.vwap;
  console.log("vwapData", vwapData);

  //vwap signal
  const vwap = latestVWAP;
  const ltpValue = ltp;
  console.log("vwap", latestVWAP);

  const diff = vwap && ltpValue ? ltpValue - vwap : 0;
  const percent = vwap ? ((diff / vwap) * 100).toFixed(2) : 0;

  const signal =
    ltpValue > vwap ? "Bullish" : ltpValue < vwap ? "Bearish" : "Neutral";
  const watchlistSet = useMemo(() => {
    return new Set(watchlist?.map((w) => w.symbol?.trim().toUpperCase()));
  }, [watchlist]);
  console.log("watchlist sey", watchlistSet);

  // const isActive = watchlistSet.has(companyCode?.trim().toUpperCase());
  const isActive = isInWatchlist(companyCode);
  console.log("isActive", isActive);
  //   const runTradingAnalysis = ({ ltp, vwap, r1, s1 }) => {
  //     console.log("========== 🚀 TRADING ANALYSIS ==========");

  //     if (!ltp || !vwap) {
  //       console.log("❌ Missing data");
  //       return;
  //     }

  //     // ===============================
  //     // 📌 ENTRY ZONE
  //     // ===============================
  //     let entry = {};
  //     const diff = Math.abs(ltp - vwap);

  //     if (diff < 0.3) {
  //       entry = {
  //         label: "No Trade",
  //         msg: "Price consolidating near VWAP",
  //         type: "neutral",
  //       };
  //     } else if (ltp > vwap) {
  //       entry = {
  //         label: "Buy Zone",
  //         msg: "Price above VWAP",
  //         type: "buy",
  //       };
  //     } else {
  //       entry = {
  //         label: "Sell Zone",
  //         msg: "Price below VWAP",
  //         type: "sell",
  //       };
  //     }

  //     console.log("📌 ENTRY ZONE:", entry);

  //     const targets = {
  //       t1: {
  //         label: "R1",
  //         value: r1,
  //         note: "Book 50–60%",
  //       },
  //       t2: {
  //         label: "S1",
  //         value: s1,
  //         note: "Trail remaining",
  //       },
  //     };

  //     console.log("🎯 EXIT TARGETS:", targets);

  //     const buffer = 0.2;
  //     const stopLoss =
  //       ltp > vwap ? (vwap - buffer).toFixed(2) : (vwap + buffer).toFixed(2);

  //     console.log("🛑 STOP LOSS:", stopLoss);

  //     let traderNote = "";

  //     if (diff < 0.3) {
  //       traderNote = `Price near VWAP. Wait:
  // Buy above ₹${(vwap + 1).toFixed(2)} → R1 ₹${r1.toFixed(2)}
  // Sell below ₹${(vwap - 1).toFixed(2)} → S1 ₹${s1.toFixed(2)}`;
  //     } else if (ltp > vwap) {
  //       traderNote = `Bullish: Buy above ₹${ltp}
  // Target ₹${r1.toFixed(2)}
  // SL ₹${vwap.toFixed(2)}`;
  //     } else {
  //       traderNote = `Bearish:  Sell below ₹${ltp}
  // Target ₹${s1.toFixed(2)}
  // SL ₹${vwap.toFixed(2)}`;
  //     }

  //     console.log("🧠 TRADER NOTE:", traderNote);

  //     const getPriority = (value) => {
  //       const d = Math.abs(value - ltp);
  //       if (d < 5) return 3;
  //       if (d < 15) return 2;
  //       return 1;
  //     };

  //     const priorities = {
  //       R1: getPriority(r1),
  //       S1: getPriority(s1),
  //     };

  //     console.log("⭐ PRIORITY:", priorities);

  //     const getStatus = (value) => {
  //       if (value > ltp) return "Above LTP";
  //       if (value < ltp) return "Below LTP";
  //       return "At LTP";
  //     };

  //     const status = {
  //       R1: getStatus(r1),
  //       S1: getStatus(s1),
  //       VWAP: getStatus(vwap),
  //     };

  //     console.log("📊 STATUS:", status);

  //     const result = {
  //       entry,
  //       targets,
  //       stopLoss,
  //       traderNote,
  //       priorities,
  //       status,
  //     };

  //     console.log("📦 FINAL RESULT:", result);
  //     console.log("========================================");

  //     return result;
  //   };
  // useEffect(() => {
  //   if (!quote || !latestVWAP || !resistanceDataToRender) return;

  //   const result = runTradingAnalysis({
  //     ltp: quote?.last_price,
  //     vwap: latestVWAP,
  //     r1: resistanceDataToRender?.classic?.R1,
  //     s1: resistanceDataToRender?.classic?.S1,
  //   });

  //   setAnalysis(result);
  // }, [quote, latestVWAP, resistanceDataToRender]);

  //new code but working one
  //   const runTradingAnalysis = ({
  //     ltp,
  //     vwap,
  //     r1,
  //     s1,
  //     rLabel = "R1",
  //     sLabel = "S1",
  //   }) => {
  //     console.log("========== 🚀 TRADING ANALYSIS ==========");

  //     if (!ltp || !vwap) {
  //       console.log("❌ Missing data");
  //       return;
  //     }

  //     // ===============================
  //     // 📌 STRATEGY PARAMETERS
  //     // ===============================
  //     const diff = Math.abs(ltp - vwap);
  //     const buffer = 0.2;
  //     const isPullbackZone = diff > 0.3 && diff < 1.5;

  //     const stopLoss =
  //       ltp > vwap ? (vwap - buffer).toFixed(2) : (vwap + buffer).toFixed(2);

  //     // ===============================
  //     // 📌 ENTRY ZONE
  //     // ===============================
  //     let entry = {};
  //     if (diff < 0.5) {
  //       entry = {
  //         label: "Neutral",
  //         msg: "Consolidating near VWAP",
  //         type: "neutral",
  //       };
  //     } else if (ltp > vwap) {
  //       entry = {
  //         label: isPullbackZone ? "Pullback Buy" : "Bullish Breakout",
  //         msg: isPullbackZone
  //           ? "Institutional Fair Price Zone"
  //           : "Momentum Active",
  //         type: "buy",
  //       };
  //     } else {
  //       entry = {
  //         label: isPullbackZone ? "Pullback Sell" : "Bearish Breakdown",
  //         msg: isPullbackZone
  //           ? "Institutional Sell Zone"
  //           : "Short Momentum Active",
  //         type: "sell",
  //       };
  //     }

  //     // ===============================
  //     // 🎯 EXIT TARGETS (Dynamic Labels)
  //     // ===============================
  //     const targets = {
  //       primary:
  //         ltp > vwap
  //           ? { label: rLabel, value: r1, note: `Book 60% at ${rLabel}` }
  //           : { label: sLabel, value: s1, note: `Book 60% at ${sLabel}` },
  //       trail: {
  //         label: "Trail",
  //         value: "Next Pivot",
  //         note: "Use 20EMA for trailing",
  //       },
  //     };

  //     // ===============================
  //     // 🧠 TRADER NOTE (Using Dynamic Labels)
  //     // ===============================
  //     let traderNote = "";
  //     if (diff < 0.5) {
  //       traderNote = `RECLAIM: Buy above ₹${(vwap + 0.8).toFixed(2)} → ${rLabel} | Sell below ₹${(vwap - 0.8).toFixed(2)} → ${sLabel}`;
  //     } else if (ltp > vwap) {
  //       traderNote = `${isPullbackZone ? "PULLBACK" : "BULLISH"}:
  // Buy above ₹${ltp}
  // Target (${rLabel}): ₹${Number(r1).toFixed(2)}
  // SL: ₹${stopLoss}`;
  //     } else {
  //       traderNote = `${isPullbackZone ? "PULLBACK" : "BEARISH"}:
  // Sell below ₹${ltp}
  // Target (${sLabel}): ₹${Number(s1).toFixed(2)}
  // SL: ₹${stopLoss}`;
  //     }

  //     // ===============================
  //     // ⭐ PRIORITY & STATUS
  //     // ===============================
  //     const getPriorityStars = (value) => {
  //       if (!value) return "⭐✩✩";
  //       const dPercent = (Math.abs(value - ltp) / ltp) * 100;
  //       if (dPercent < 0.5) return "⭐⭐⭐";
  //       if (dPercent < 1.2) return "⭐⭐✩";
  //       return "⭐✩✩";
  //     };

  //     const getStatus = (val) =>
  //       val > ltp ? "Above LTP" : val < ltp ? "Below LTP" : "At LTP";

  //     const priorities = {
  //       [rLabel]: getPriorityStars(r1),
  //       [sLabel]: getPriorityStars(s1),
  //     };

  //     const status = {
  //       [rLabel]: getStatus(r1),
  //       [sLabel]: getStatus(s1),
  //       VWAP: getStatus(vwap),
  //     };

  //     return { entry, targets, stopLoss, traderNote, priorities, status };
  //   };

  //new code with exit and entry
  // const runTradingAnalysis = ({
  //   ltp,
  //   vwap,
  //   prevClose,
  //   prevVWAP,
  //   volume,
  //   avgVolume,
  //   r1,
  //   s1,
  //   rLabel = "R1",
  //   sLabel = "S1",
  //   position,
  // }) => {
  //   if (!ltp || !vwap) return {};

  //   // ===============================
  //   // ⚙️ CONFIG
  //   // ===============================
  //   // const ENTRY_ZONE_PCT = 0.0005;
  //   const ENTRY_ZONE_PCT = 0.002; // 0.2% (better)
  //   // 0.05% (matches Python)
  //   const STOP_BUFFER = 0.001;
  //   const TARGET_PCT = 0.005; // 0.5% (matches Python)

  //   let entry = {};
  //   let signal = null; // 🔥 BUY signal
  //   let exit = null; // 🔥 SELL signal
  //   let newPosition = position;

  //   const entryZoneUpper = vwap * (1 + ENTRY_ZONE_PCT);

  //   const isNearVWAP = ltp >= vwap && ltp <= entryZoneUpper;

  //   const isReclaim = prevClose < prevVWAP && ltp > vwap;

  //   const isHighVolume = !volume || !avgVolume || volume > avgVolume * 0.8;

  //   const isAboveVWAP = ltp > vwap;
  //   if (!position?.inPosition) {
  //     if (isReclaim && isHighVolume) {
  //       entry = {
  //         label: "VWAP Reclaim Buy",
  //         msg: "Strong breakout above VWAP",
  //         type: "buy",
  //       };

  //       signal = `BUY (Reclaim) @ ₹${ltp}`;

  //       newPosition = {
  //         inPosition: true,
  //         entryPrice: ltp,
  //       };
  //     } else if (isNearVWAP) {
  //       entry = {
  //         label: "Pullback Buy",
  //         msg: "VWAP Support Zone",
  //         type: "buy",
  //       };

  //       signal = `BUY (Pullback) @ ₹${ltp}`;

  //       newPosition = {
  //         inPosition: true,
  //         entryPrice: ltp,
  //       };
  //     } else {
  //       entry = {
  //         label: "No Trade",
  //         msg: "Wait for VWAP setup",
  //         type: "neutral",
  //       };
  //     }
  //   } else if (position?.inPosition) {
  //     const entryPrice = position.entryPrice;

  //     const target = entryPrice * (1 + TARGET_PCT);
  //     const stopLoss = vwap * (1 - STOP_BUFFER);

  //     // 🚀 TARGET HIT
  //     if (ltp >= target) {
  //       exit = `Target Hit 🚀 SELL @ ₹${ltp}`;

  //       newPosition = {
  //         inPosition: false,
  //         entryPrice: null,
  //       };
  //     } else if (ltp < stopLoss) {
  //       exit = `VWAP Breakdown ❌ SELL @ ₹${ltp}`;

  //       newPosition = {
  //         inPosition: false,
  //         entryPrice: null,
  //       };
  //     }

  //     entry = {
  //       label: "In Trade",
  //       msg: `Entry ₹${entryPrice} | LTP ₹${ltp}`,
  //       type: "active",
  //     };
  //   } else if (isAboveVWAP) {
  //     entry = {
  //       label: "Trend Buy",
  //       msg: "Price holding above VWAP",
  //       type: "buy",
  //     };

  //     signal = `BUY (Trend) @ ₹${ltp}`;
  //   } else {
  //     entry = {
  //       label: "No Trade",
  //       msg: "Wait for VWAP setup",
  //       type: "neutral",
  //     };
  //   }

  //   if (!signal && !position?.inPosition) {
  //     if (ltp > vwap) {
  //       signal = `BUY (Fallback) @ ₹${ltp}`;
  //       entry = {
  //         label: "Fallback Buy",
  //         msg: "Above VWAP (fallback)",
  //         type: "buy",
  //       };

  //       // ❌ DON'T CHANGE POSITION HERE
  //       newPosition = position;
  //     } else if (ltp < vwap) {
  //       signal = `SELL (Fallback) @ ₹${ltp}`;
  //       entry = {
  //         label: "Fallback Sell",
  //         msg: "Below VWAP (fallback)",
  //         type: "sell",
  //       };

  //       // ❌ DON'T CHANGE POSITION HERE
  //       newPosition = position;
  //     }
  //   }

  //   // 🔥 Force exit visibility when in trade but no exit hit
  //   if (position?.inPosition && !exit) {
  //     exit = `HOLD → LTP ₹${ltp}`;
  //   }

  //   const targets = {
  //     primary:
  //       ltp > vwap
  //         ? { label: rLabel, value: r1 }
  //         : { label: sLabel, value: s1 },
  //   };

  //   // ===============================
  //   // 🛑 STOP LOSS DISPLAY
  //   // ===============================
  //   const stopLossDisplay =
  //     ltp > vwap
  //       ? (vwap * (1 - STOP_BUFFER)).toFixed(2)
  //       : (vwap * (1 + STOP_BUFFER)).toFixed(2);

  //   // ===============================
  //   // 🧠 TRADER NOTE
  //   // ===============================
  //   const traderNote = position?.inPosition
  //     ? `IN TRADE → Entry ₹${position.entryPrice} | Target ₹${(
  //         position.entryPrice *
  //         (1 + TARGET_PCT)
  //       ).toFixed(2)}`
  //     : signal || `WAIT → VWAP ₹${vwap.toFixed(2)}`;
  //   console.log({
  //     ltp,
  //     vwap,
  //     isAboveVWAP: ltp > vwap,
  //     isNearVWAP,
  //     isReclaim,
  //     volume,
  //     avgVolume,
  //     isHighVolume,
  //     inPosition: position?.inPosition,
  //   });
  //   return {
  //     entry,
  //     signal, // 🔥 NEW
  //     exit, // 🔥 NEW
  //     targets,
  //     stopLoss: stopLossDisplay,
  //     traderNote,
  //     newPosition, // 🔥 IMPORTANT
  //   };
  // };

  // const runTradingAnalysis = ({
  //   ltp,
  //   vwap,
  //   prevClose,
  //   prevVWAP,
  //   volume,
  //   avgVolume,
  //   r1,
  //   s1,
  //   rLabel = "R1",
  //   sLabel = "S1",
  //   position,
  // }) => {
  //   if (!ltp || !vwap) return {};

  //   // ===============================
  //   // ⚙️ CONFIG
  //   // ===============================
  //   const ENTRY_ZONE_PCT = 0.002;
  //   const STOP_BUFFER = 0.001;
  //   const TARGET_PCT = 0.005;

  //   let entry = {};
  //   let signal = null;
  //   let exit = null;
  //   let newPosition = position;

  //   // ===============================
  //   // 🧠 ENTRY LOGIC
  //   // ===============================
  //   const entryZoneUpper = vwap * (1 + ENTRY_ZONE_PCT);

  //   const isNearVWAP = ltp >= vwap && ltp <= entryZoneUpper;
  //   const isReclaim = prevClose < prevVWAP && ltp > vwap;
  //   const isHighVolume = !volume || !avgVolume || volume > avgVolume * 0.8;

  //   const isAboveVWAP = ltp > vwap;

  //   // ===============================
  //   // ENTRY
  //   // ===============================
  //   if (!position?.inPosition) {
  //     if (isReclaim && isHighVolume) {
  //       entry = {
  //         label: "VWAP Reclaim Buy",
  //         msg: "Strong breakout above VWAP",
  //         type: "buy",
  //       };

  //       signal = `BUY (Reclaim) @ ₹${ltp}`;

  //       // ✅ FIXED (no loop)
  //       if (!position?.inPosition) {
  //         newPosition = {
  //           inPosition: true,
  //           entryPrice: Number(ltp.toFixed(2)),
  //         };
  //       } else {
  //         newPosition = position;
  //       }
  //     } else if (isNearVWAP) {
  //       entry = {
  //         label: "Pullback Buy",
  //         msg: "VWAP Support Zone",
  //         type: "buy",
  //       };

  //       signal = `BUY (Pullback) @ ₹${ltp}`;

  //       // ✅ FIXED
  //       if (!position?.inPosition) {
  //         newPosition = {
  //           inPosition: true,
  //           entryPrice: Number(ltp.toFixed(2)),
  //         };
  //       } else {
  //         newPosition = position;
  //       }
  //     } else {
  //       entry = {
  //         label: "No Trade",
  //         msg: "Wait for VWAP setup",
  //         type: "neutral",
  //       };
  //     }
  //   }

  //   // ===============================
  //   // EXIT
  //   // ===============================
  //   else if (position?.inPosition) {
  //     const entryPrice = position.entryPrice;

  //     const target = entryPrice * (1 + TARGET_PCT);
  //     const stopLoss = vwap * (1 - STOP_BUFFER);

  //     if (ltp >= target) {
  //       exit = `Target Hit 🚀 SELL @ ₹${ltp}`;

  //       // ✅ FIXED
  //       if (position?.inPosition) {
  //         newPosition = {
  //           inPosition: false,
  //           entryPrice: null,
  //         };
  //       } else {
  //         newPosition = position;
  //       }
  //     } else if (ltp < stopLoss) {
  //       exit = `VWAP Breakdown ❌ SELL @ ₹${ltp}`;

  //       // ✅ FIXED
  //       if (position?.inPosition) {
  //         newPosition = {
  //           inPosition: false,
  //           entryPrice: null,
  //         };
  //       } else {
  //         newPosition = position;
  //       }
  //     }

  //     entry = {
  //       label: "In Trade",
  //       msg: `Entry ₹${entryPrice} | LTP ₹${ltp}`,
  //       type: "active",
  //     };
  //   }

  //   // ===============================
  //   // DEAD BLOCK (SAFE VERSION)
  //   // ===============================
  //   else if (isAboveVWAP) {
  //     entry = {
  //       label: "Trend Buy",
  //       msg: "Price holding above VWAP",
  //       type: "buy",
  //     };

  //     if (!signal) {
  //       signal = `BUY (Trend) @ ₹${ltp}`;
  //     }

  //     newPosition = position; // ✅ prevent loop
  //   } else {
  //     entry = {
  //       label: "No Trade",
  //       msg: "Wait for VWAP setup",
  //       type: "neutral",
  //     };
  //   }

  //   // ===============================
  //   // FALLBACK SIGNAL
  //   // ===============================
  //   if (!signal && !position?.inPosition) {
  //     if (ltp > vwap) {
  //       signal = `BUY (Fallback) @ ₹${ltp}`;
  //       entry = {
  //         label: "Fallback Buy",
  //         msg: "Above VWAP (fallback)",
  //         type: "buy",
  //       };

  //       newPosition = position; // ✅ important
  //     } else if (ltp < vwap) {
  //       signal = `SELL (Fallback) @ ₹${ltp}`;
  //       entry = {
  //         label: "Fallback Sell",
  //         msg: "Below VWAP (fallback)",
  //         type: "sell",
  //       };

  //       newPosition = position; // ✅ important
  //     }
  //   }

  //   // ===============================
  //   // HOLD STATE
  //   // ===============================
  //   if (position?.inPosition && !exit) {
  //     exit = `HOLD → LTP ₹${ltp}`;
  //   }

  //   // ===============================
  //   // TARGETS
  //   // ===============================
  //   const targets = {
  //     primary:
  //       ltp > vwap
  //         ? { label: rLabel, value: r1 }
  //         : { label: sLabel, value: s1 },
  //   };

  //   // ===============================
  //   // STOP LOSS DISPLAY
  //   // ===============================
  //   const stopLossDisplay =
  //     ltp > vwap
  //       ? (vwap * (1 - STOP_BUFFER)).toFixed(2)
  //       : (vwap * (1 + STOP_BUFFER)).toFixed(2);

  //   // ===============================
  //   // FINAL SIGNAL SAFETY
  //   // ===============================
  //   if (!signal && position?.inPosition) {
  //     signal = "IN TRADE";
  //   }

  //   // ===============================
  //   // TRADER NOTE
  //   // ===============================
  //   const traderNote = position?.inPosition
  //     ? `IN TRADE → Entry ₹${position.entryPrice} | Target ₹${(
  //         position.entryPrice *
  //         (1 + TARGET_PCT)
  //       ).toFixed(2)}`
  //     : signal || `WAIT → VWAP ₹${vwap.toFixed(2)}`;

  //   console.log({
  //     ltp,
  //     vwap,
  //     isAboveVWAP: ltp > vwap,
  //     isNearVWAP,
  //     isReclaim,
  //     volume,
  //     avgVolume,
  //     isHighVolume,
  //     inPosition: position?.inPosition,
  //   });

  //   return {
  //     entry,
  //     signal,
  //     exit,
  //     targets,
  //     stopLoss: stopLossDisplay,
  //     traderNote,
  //     newPosition,
  //   };
  // };

  const getStatus = (value, ltp) => {
    if (!ltp || !value) return "";

    if (value > ltp) return "Above LTP";
    if (value < ltp) return "Below LTP";
    return "At LTP";
  };

  const getPriority = (value, ltp) => {
    if (!ltp || !value) return 1;

    const diff = Math.abs(value - ltp);

    if (diff < 5) return 3;
    if (diff < 15) return 2;
    return 1;
  };

  const renderStars = (count) => {
    return [1, 2, 3].map((i) => (
      <span key={i} style={{ fontSize: "1rem", marginRight: "2px" }}>
        {i <= count ? (
          <FaStar style={{ color: "#FFD700" }} /> // Gold
        ) : (
          <FaRegStar style={{ color: "#CBD5E1" }} /> // Refined Grey
        )}
      </span>
    ));
  };

  const getNearestLevels = (levelsObj, ltp) => {
    if (!levelsObj || !ltp) return {};

    // 🔴 ONLY RESISTANCE KEYS
    const resistanceLevels = Object.entries(levelsObj).filter(([key]) =>
      key.startsWith("R"),
    );

    // 🟢 ONLY SUPPORT KEYS
    const supportLevels = Object.entries(levelsObj).filter(([key]) =>
      key.startsWith("S"),
    );

    let nearestResistance = null;
    let nearestSupport = null;

    let minResDiff = Infinity;
    let minSupDiff = Infinity;

    // 🔴 RESISTANCE LOGIC
    resistanceLevels.forEach(([key, value]) => {
      if (!value) return;

      const diff = value - ltp;

      if (diff > 0 && diff < minResDiff) {
        minResDiff = diff;
        nearestResistance = { key, value };
      }
    });

    // 🟢 SUPPORT LOGIC
    supportLevels.forEach(([key, value]) => {
      if (!value) return;

      const diff = value - ltp;

      if (diff < 0 && Math.abs(diff) < minSupDiff) {
        minSupDiff = Math.abs(diff);
        nearestSupport = { key, value };
      }
    });

    return { nearestResistance, nearestSupport };
  };
  const { nearestResistance, nearestSupport } = getNearestLevels(
    resistanceDataToRender?.classic,
    ltp,
  );
  const runTradingAnalysis = ({
    ltp,
    vwap,
    prevClose,
    prevVWAP,
    volume,
    avgVolume,
    r1,
    s1,
    rLabel = "R1",
    sLabel = "S1",
    position,
  }) => {
    if (!ltp || !vwap) return {};

    // ===============================
    // ⚙️ CONFIG
    // ===============================
    const ENTRY_ZONE_PCT = 0.002;
    const STOP_BUFFER = 0.001;
    const TARGET_PCT = 0.005;

    let entry = {};
    let signal = null;
    let exit = null;
    let newPosition = position;

    const entryZoneUpper = vwap * (1 + ENTRY_ZONE_PCT);

    const isNearVWAP = ltp >= vwap && ltp <= entryZoneUpper;
    const isReclaim = prevClose < prevVWAP && ltp > vwap;
    const isHighVolume = !volume || !avgVolume || volume > avgVolume * 0.8;

    const isAboveVWAP = ltp > vwap;

    if (!position?.inPosition) {
      if (isReclaim && isHighVolume) {
        entry = {
          label: "VWAP Reclaim Buy",
          msg: "Strong breakout above VWAP",
          type: "buy",
        };

        signal = `BUY (Reclaim) @ ₹${ltp}`;

        if (!position?.inPosition) {
          newPosition = {
            inPosition: true,
            entryPrice: Number(ltp.toFixed(2)),
          };
        } else {
          newPosition = position;
        }
      } else if (isNearVWAP) {
        entry = {
          label: "Pullback Buy",
          msg: "VWAP Support Zone",
          type: "buy",
        };

        signal = `BUY (Pullback) @ ₹${ltp}`;

        if (!position?.inPosition) {
          newPosition = {
            inPosition: true,
            entryPrice: Number(ltp.toFixed(2)),
          };
        } else {
          newPosition = position;
        }
      } else {
        entry = {
          label: "No Trade",
          msg: "Wait for VWAP setup",
          type: "neutral",
        };
      }
    }

    // ===============================
    // EXIT
    // ===============================
    else if (position?.inPosition) {
      const entryPrice = position.entryPrice;

      const target = entryPrice * (1 + TARGET_PCT);
      const stopLoss = vwap * (1 - STOP_BUFFER);

      if (ltp >= target) {
        exit = `Target Hit 🚀 SELL @ ₹${ltp}`;

        if (position?.inPosition) {
          newPosition = {
            inPosition: false,
            entryPrice: null,
          };
        } else {
          newPosition = position;
        }
      } else if (ltp < stopLoss) {
        exit = `VWAP Breakdown ❌ SELL @ ₹${ltp}`;

        if (position?.inPosition) {
          newPosition = {
            inPosition: false,
            entryPrice: null,
          };
        } else {
          newPosition = position;
        }
      }

      entry = {
        label: "In Trade",
        msg: `Entry ₹${entryPrice} | LTP ₹${ltp}`,
        type: "active",
      };
    }

    // ===============================
    // DEAD BLOCK SAFE (NOT REMOVED)
    // ===============================
    else if (isAboveVWAP) {
      entry = {
        label: "Trend Buy",
        msg: "Price holding above VWAP",
        type: "buy",
      };

      if (!signal) {
        signal = `BUY (Trend) @ ₹${ltp}`;
      }

      newPosition = position; // prevent loop
    } else {
      entry = {
        label: "No Trade",
        msg: "Wait for VWAP setup",
        type: "neutral",
      };
    }

    if (!signal && !position?.inPosition) {
      if (ltp > vwap) {
        signal = `BUY (Fallback) @ ₹${ltp}`;
        entry = {
          label: "Fallback Buy",
          msg: "Above VWAP (fallback)",
          type: "buy",
        };

        newPosition = position;
      } else if (ltp < vwap) {
        signal = `SELL (Fallback) @ ₹${ltp}`;
        entry = {
          label: "Fallback Sell",
          msg: "Below VWAP (fallback)",
          type: "sell",
        };

        newPosition = position;
      }
    }

    // ===============================
    // HOLD STATE
    // ===============================
    if (position?.inPosition && !exit) {
      exit = `HOLD → LTP ₹${ltp}`;
    }

    // ===============================
    // TARGETS
    // ===============================
    const targets = {
      primary:
        ltp > vwap
          ? { label: rLabel, value: r1 }
          : { label: sLabel, value: s1 },
    };

    // ===============================
    // STOP LOSS DISPLAY
    // ===============================
    const stopLossDisplay =
      ltp > vwap
        ? (vwap * (1 - STOP_BUFFER)).toFixed(2)
        : (vwap * (1 + STOP_BUFFER)).toFixed(2);

    // ===============================
    // FINAL SIGNAL SAFETY
    // ===============================
    if (!signal && position?.inPosition) {
      signal = "IN TRADE";
    }

    let pythonSignal = null;
    let pythonTrend = null;

    const ENTRY_ZONE_PCT_PY = 0.002; // Widened to 0.2% to match main strategy
    const TARGET_PCT_PY = 0.01; // 1.0% target gain
    const entryZoneUpperPy = vwap * (1 + ENTRY_ZONE_PCT_PY);

    if (!position?.inPosition) {
      if (ltp >= vwap && ltp <= entryZoneUpperPy) {
        pythonSignal = `
       
         BUY at ₹${ltp}, VWAP ₹${vwap.toFixed(2)}`;
        pythonTrend = "BULLISH ENTRY";
        // setTrend(pythonTrend);
      } else if (ltp > vwap) {
        // ADDED: Fallback signal so it's not null when price is high
        pythonSignal = `
    
        LTP ₹${ltp} is above VWAP`;
        pythonTrend = "TRENDING BULLISH ";
        // setTrend(pythonTrend);
      }
    } else if (position?.inPosition) {
      const entryPrice = position.entryPrice;

      if (ltp >= entryPrice * (1 + TARGET_PCT_PY)) {
        pythonSignal = `
       SELL at ₹${ltp}, Gain: 1%`;
        pythonTrend = "EXIT PROFIT";
        // setTrend(pythonTrend);
      } else if (ltp < vwap) {
        pythonSignal = `LOSS SELL at ₹${ltp}, Below VWAP`;
        pythonTrend = "EXIT STOP";
        // setTrend(pythonTrend);
      }
    }

    // Trader Note logic for display
    const traderNote = position?.inPosition
      ? `IN TRADE → Entry ₹${position.entryPrice} | Target ₹${(
          position.entryPrice *
          (1 + TARGET_PCT_PY)
        ).toFixed(2)}`
      : pythonSignal || `WAIT → VWAP ₹${vwap.toFixed(2)}`;
    console.log(
      "Final values",
      signal,
      exit,
      targets,
      stopLossDisplay,
      traderNote,
      newPosition,
      pythonSignal,
      pythonTrend,
    );
    return {
      entry,
      signal,
      exit,
      targets,
      stopLoss: stopLossDisplay,
      traderNote,
      newPosition,
      pythonSignal,
      pythonTrend, // ✅ NEW
    };
  };
  const analysis = useMemo(() => {
    if (!quote || !latestVWAP) return null;

    return runTradingAnalysis({
      ltp: quote?.last_price,
      vwap: latestVWAP,

      // 🔥 NEW (add these if available, else fallback)
      prevClose: prevClose || quote?.last_price,
      prevVWAP: latestVWAP,
      volume: quote?.volume ?? 0,
      avgVolume: 0,

      r1: nearestResistance?.value,
      s1: nearestSupport?.value,
      rLabel: nearestResistance?.key,
      sLabel: nearestSupport?.key,

      // 🔥 CRITICAL
      position,
    });
  }, [
    quote?.last_price,
    latestVWAP,
    nearestResistance,
    nearestSupport,
    position, // 🔥 MUST ADD
  ]);

  useEffect(() => {
    if (!analysis?.newPosition) return;

    const prev = position || {};
    const next = analysis.newPosition || {};

    const isSame =
      prev.inPosition === next.inPosition &&
      Number(prev.entryPrice || 0).toFixed(2) ===
        Number(next.entryPrice || 0).toFixed(2);

    if (!isSame) {
      setPosition(next);
    }
  }, [analysis?.newPosition]);
  console.log("Analysis", analysis);
  console.log(
    "Nearest Resistance, nearest support",
    nearestResistance,
    nearestSupport,
  );

  //signalInfoFallback
  const getSignalInfo = (signal) => {
    if (!signal) return "";

    if (signal.includes("Fallback")) {
      return "Fallback = Weak signal based on VWAP direction when no strong setup is present. Use cautiously.";
    }

    if (signal.includes("Reclaim")) {
      return "VWAP Reclaim = Strong bullish signal when price crosses above VWAP with momentum.";
    }

    if (signal.includes("Pullback")) {
      return "Pullback = Price bouncing near VWAP support zone. Medium confidence entry.";
    }

    return "Trading signal based on VWAP strategy.";
  };
  //atr function
  const calculateATR = (candles, period = 10) => {
    const tr = [];

    for (let i = 1; i < candles.length; i++) {
      const high = candles[i].high;
      const low = candles[i].low;
      const prevClose = candles[i - 1].close;

      const trueRange = Math.max(
        high - low,
        Math.abs(high - prevClose),
        Math.abs(low - prevClose),
      );

      tr.push(trueRange);
    }

    return tr.map((_, i, arr) => {
      if (i < period) return null;
      const slice = arr.slice(i - period, i);
      return slice.reduce((a, b) => a + b, 0) / period;
    });
  };

  //ut bot logic
  const calculateUTBot = (candles, keyValue = 3, atrPeriod = 10) => {
    const atr = calculateATR(candles, atrPeriod);

    let trailingStop = 0;
    let prevTrailingStop = 0;

    const result = [];

    for (let i = 0; i < candles.length; i++) {
      const src = candles[i].close;
      const prevSrc = candles[i - 1]?.close;

      const nLoss = (atr[i] || 0) * keyValue;

      if (i === 0) {
        trailingStop = src;
      } else {
        if (src > prevTrailingStop && prevSrc > prevTrailingStop) {
          trailingStop = Math.max(prevTrailingStop, src - nLoss);
        } else if (src < prevTrailingStop && prevSrc < prevTrailingStop) {
          trailingStop = Math.min(prevTrailingStop, src + nLoss);
        } else {
          trailingStop = src > prevTrailingStop ? src - nLoss : src + nLoss;
        }
      }

      const buy = prevSrc < prevTrailingStop && src > trailingStop;

      const sell = prevSrc > prevTrailingStop && src < trailingStop;

      result.push({
        time: candles[i].time,
        trailingStop,
        buy,
        sell,
      });

      prevTrailingStop = trailingStop;
    }

    return result;
  };

  //signaltool
  const getSignalTooltip = (signal) => {
    if (!signal) return [];

    if (signal.includes("Fallback")) {
      return [
        { id: 1, text: "Fallback Signal" },
        { id: 2, text: "Weak direction based on VWAP" },
        { id: 3, text: "No strong confirmation present" },
        { id: 4, text: "Use with caution" },
      ];
    }

    if (signal.includes("Reclaim")) {
      return [
        { id: 1, text: "VWAP Reclaim" },
        { id: 2, text: "Strong bullish signal" },
        { id: 3, text: "Price crossed above VWAP" },
      ];
    }

    if (signal.includes("Pullback")) {
      return [
        { id: 1, text: "VWAP Pullback" },
        { id: 2, text: "Medium strength signal" },
        { id: 3, text: "Price bouncing near VWAP" },
      ];
    }

    return [
      { id: 1, text: "Trading Signal" },
      { id: 2, text: "Based on strategy conditions" },
    ];
  };
  const InfoTooltip = ({ text }) => {
    if (!Array.isArray(text)) return null;

    return (
      <span className="table-tooltip-wrapper">
        <span style={{ color: "black" }}> ⓘ</span>
        <div className="table-tooltip-content">
          {text.map((item) => (
            <div key={item.id} className="tooltip-line">
              {item.text}
            </div>
          ))}
        </div>
      </span>
    );
  };
  console.log("Last signal", lastUTSignal);
  const trades = calculateTradePerformance(crossovers, selectedPriceData);

  useEffect(() => {
    console.log("MA DATA", maData);

    console.log("LTP", ltp);

    console.log("ROWS", rows);
  }, [maData, ltp, rows]);

  return (
    <>
      <div className="last-updated-head">
        {lastUpdated && <span>As on {lastUpdated}</span>}
        <FiRefreshCw
          onClick={handleRefresh}
          size={18}
          style={{
            cursor: "pointer",
            transition: "0.2s",
          }}
          onMouseOver={(e) => (e.target.style.color = "#2fd18a")}
          onMouseOut={(e) => (e.target.style.color = "#9ca3af")}
        />
      </div>
      {/* {loading && !error && !quote && (
        <p
          style={{
            fontSize: "1rem",
            fontWeight: "700",
          
            display: "flex",
            gap: "1rem",
          }}
        >
          Fetching Live data..{" "}
          <span style={{ paddingLeft: "10px", marginTop: "5px" }}>
            <FaSpinner />
          </span>
        </p>
      )} */}

      {/* same here remove changes */}
      {!liveReady && !error && (
        <p
          style={{
            fontSize: "1rem",
            fontWeight: "700",
            display: "flex",
            gap: "1rem",
          }}
        >
          Fetching Live data...
          <span style={{ paddingLeft: "10px", marginTop: "5px" }}>
            <FaSpinner />
          </span>
        </p>
      )}

      {/* Remove it when done changes */}
      {error && (
        <div
          style={{
            marginTop: "20px",
            padding: "14px",
            borderLeft: "5px solid #dc2626",
            background: "#fee2e2",
            color: "#7f1d1d",
            fontWeight: 600,
            borderRadius: "8px",
          }}
        >
          {error}
        </div>
      )}
      {/* <div className="export-files">
        <button className="rec-btn" onClick={handleDownloadReport}>
          Download Report
        </button>
      </div> */}

      {liveReady && quote && (
        <>
          <div className={`page-container ${chatOpen ? "shrink" : ""}`}>
            <div className="page-inner-container">
              <div className="stock-detail-card">
                <div className="analysis-container">
                  <div className="analysis-header">
                    <div className="analysis-head-name">
                      <div className="analysis-head-div">
                        <h2 className="stock-title">{stockName?.company}</h2>
                        <span className="stock-tag">{companyCode}</span>
                      </div>

                      <div className="price-chip-head">
                        <div className="price-chip">
                          <p className="label">LTP</p>
                          <h3 className="value" style={{ color: "#2563eb" }}>
                            ₹{quote?.last_price}
                          </h3>
                        </div>

                        <div className="price-chip">
                          <p className="label">% Change</p>
                          <h3
                            className="value positive"
                            style={{
                              color: percent_change > 0 ? "#249966" : "#f87171",
                            }}
                          >
                            {percent_change}%
                          </h3>
                        </div>
                        <div className="price-chip">
                          <p className="label">Open</p>
                          <h3 className="value">₹{stock?.open}</h3>
                        </div>
                        <div className="price-chip">
                          <p className="label">Close</p>
                          <h3 className="value">₹{prev_close}</h3>
                        </div>

                        <div className="price-chip">
                          <p className="label">Forecast Price</p>
                          <h3
                            className="value"
                            style={{
                              color:
                                Number.isFinite(target_price) &&
                                target_price > quote?.last_price
                                  ? "#249966"
                                  : "#f87171",
                            }}
                          >
                            {target_price && Number.isFinite(target_price)
                              ? `₹${target_price}`
                              : "—"}
                          </h3>
                        </div>
                        <div className="price-chip">
                          <p className="label">VWAP</p>
                          <h3
                            className="value"
                            // style={{
                            //   color:
                            //     Number.isFinite(target_price) &&
                            //     target_price > quote?.last_price
                            //       ? "#249966"
                            //       : "#f87171",
                            // }}
                          >
                            ₹{latestVWAP?.toFixed(2) || "--"}
                            {/* {Number.isFinite(target_price) ? target_price : "—"} */}
                          </h3>
                        </div>
                      </div>
                    </div>

                    <div className="action-buttons">
                      <button
                        className="rec-btn"
                        onClick={handleDownloadReport}
                      >
                        Download Report
                      </button>
                      {/* <button className="btn-buy">Buy</button>
              <button className="btn-sell">Sell</button>
              <button className="btn-hold">Hold</button> */}
                      {/* <button
                        className="btn-star"
                        onClick={() => handleAdd(companyCode)}
                      >
                        ★
                      </button> */}
                      {/* <span
                        className={`watchlist-icon  ${
                          isInWatchlist(stock?.symbol) ? "active" : "inactive"
                        }`}
                        onClick={() => handleAdd(stock?.symbol)}
                      >
                        {isInWatchlist(stock?.symbol) ? (
                          <FaStar className="star" />
                        ) : (
                          <FiStar className="star" />
                        )}
                      </span> */}

                      <span
                        className={`watchlist-icon ${isActive ? "active" : "inactive"}`}
                        onClick={() => handleAdd(companyCode)}
                      >
                        {isActive ? (
                          <FaStar className="star" />
                        ) : (
                          <FiStar className="star" />
                        )}
                      </span>
                    </div>
                  </div>
                  <div className="outer-insight-box">
                    <div
                      className="insight-box"
                      style={{
                        borderLeft:
                          timeFrame === "min"
                            ? `4px solid ${color1}`
                            : `4px solid ${color}`,
                      }}
                    >
                      <div className="insight-head-div">
                        <p className="insight-head">Phro Trader Insights</p>
                        {/* 
                        <select
                          name=""
                          id=""
                          value={timeFrame}
                          onChange={(e) => setTimeFrame(e.target.value)}
                          style={{
                            background: "inherit",
                            // color: "white",
                            fontWeight: "600",
                            color: "black",
                            // boxShadow: "0px 2px 8px rgba(255, 255, 255, 0.2)",
                            boxShadow: " 0 4px 12px rgba(0, 0, 0, 0.4)",
                            padding: "5px 7px",
                            borderRadius: "10px",
                          }}
                        >
                          <option value="min">Minute</option>
                          <option value="day">Day</option>
                        </select> */}
                      </div>
                      {/* <p className="insight-head">Phro Trader Insights</p> */}
                      <div className="vwap-rsi-signal">
                        <div className="sub-insight vwap-card">
                          <div className="vwap-header">
                            <div
                              className="vwap-sub-header"
                              style={{ marginBottom: "12px" }}
                            >
                              <span>RSI & MACD BASED SIGNAL</span>
                              <select
                                name=""
                                id=""
                                value={timeFrame}
                                onChange={(e) => setTimeFrame(e.target.value)}
                                style={{
                                  background: "inherit",

                                  fontWeight: "600",
                                  color: "black",

                                  boxShadow: " 0 4px 12px rgba(0, 0, 0, 0.4)",
                                  padding: "5px 7px",
                                  borderRadius: "10px",
                                }}
                              >
                                <option value="min">Minute</option>
                                <option value="day">Day</option>
                              </select>
                            </div>

                            {/* <div
                              className="insight-text"
                              style={{
                                color: timeFrame === "min" ? color1 : color,
                              }}
                            >
                              {timeFrame === "min" ? result1 : result}
                            </div> */}
                          </div>

                          <div className="insight-sub-div">
                            <div
                              className="insight-text"
                              style={{
                                color: timeFrame === "min" ? color1 : color,
                              }}
                            >
                              {timeFrame === "min" ? result1 : result}
                            </div>
                            <button
                              className="insight-tag"
                              style={{
                                backgroundColor:
                                  timeFrame === "min" ? color1 : color,
                                color: "white",
                              }}
                            >
                              {timeFrame === "min" ? prediction1 : prediction}
                            </button>
                          </div>
                        </div>

                        <div className="vwap-card">
                          <div className="vwap-header">
                            <div className="vwap-sub-header">
                              <span>VWAP MOMENTUM SIGNAL</span>
                              <span className="intraday-badge">Intraday</span>
                            </div>
                            <div className="insight-sub-div">
                              <span
                                style={{
                                  alignSelf: "center",
                                }}
                              >
                                LTP - VWAP:
                                <span
                                  style={{
                                    color: diff > 0 ? "#16a34a" : "#dc2626",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {diff > 0 ? " +" : ""}
                                  {diff.toFixed(2)} (
                                  {percent > 0 ? `+${percent}` : `${percent}`}
                                  %)
                                </span>
                              </span>

                              <button
                                className={` insight-tag
                              vwap-badge ${
                                signal === "Bullish"
                                  ? "green"
                                  : signal === "Bearish"
                                    ? "red"
                                    : "grey"
                              }`}
                              >
                                {signal}
                              </button>
                            </div>
                          </div>

                          <p className="vwap-text">
                            {signal === "Bullish" &&
                              `Price is above VWAP (₹${vwap?.toFixed(
                                2,
                              )}) — bullish intraday strength.`}

                            {signal === "Bearish" &&
                              `Price is below VWAP (₹${vwap?.toFixed(
                                2,
                              )}) — bearish pressure likely.`}

                            {signal === "Neutral" &&
                              `Price is near VWAP (₹${vwap?.toFixed(
                                2,
                              )}) — wait for breakout.`}
                          </p>
                        </div>
                        <div className="vwap-card">
                          <div className="vwap-header">
                            <div className="sub-vwap-head">
                              <div className="vwap-sub-header">
                                <span>UT BOT SIGNAL</span>
                              </div>
                              <button
                                className={` insight-tag
                              vwap-badge ${
                                lastUTSignal?.text === "BUY"
                                  ? "green"
                                  : lastUTSignal?.text === "SELL"
                                    ? "red"
                                    : "grey"
                              }`}
                              >
                                {`${lastUTSignal?.text === "BUY" ? "Bullish" : "Bearish"}`}
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="vwap-card">
                          <div className="vwap-header">
                            <div className="sub-vwap-head">
                              <div className="vwap-sub-header">
                                <span>BB SIGNAL</span>
                              </div>
                              <button
                                className={` insight-tag
                              vwap-badge ${
                                bbgSignal === "BUY"
                                  ? "green"
                                  : bbgSignal === "SELL"
                                    ? "red"
                                    : "grey"
                              }`}
                              >
                                {bbgSignal === "BUY" ? "Bullish" : "Bearish"}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>{" "}
                    {/* <div className="tp-critical">
                      <h5>⭐ Critical Levels</h5>

                      <p>
                        Resistance: ₹
                        {resistanceDataToRender?.classic?.R1?.toFixed(2)}
                      </p>
                      <p>VWAP: ₹{latestVWAP?.toFixed(2)}</p>
                      <p>
                        Support: ₹
                        {resistanceDataToRender?.classic?.S1?.toFixed(2)}
                      </p>
                      <p>Stop Loss: ₹{analysis?.stopLoss}</p>
                    </div> */}
                    {/* Near Pivots */}
                    {/* <div className="tp-card tp-critical-card tp-insight">
                      <h4 className="tp-title insight-critical-title">
                      
                        Near Pivots ⭐ ⭐ ⭐{" "}
                      </h4>
                    
                      <div className="near-pivot-grid">
                      
                        <div className="np-col">
                          <div className="np-group">
                            <div className="np-row">
                              <span className="np-resistance">
                                Key Resistance
                              </span>
                              <span className="np-value red">
                                ₹{nearestResistance?.value?.toFixed(2)}
                              </span>
                            </div>
                            <span className="np-sub">(Above LTP)</span>
                          </div>

                          <div className="np-row">
                            <span className="np-support">Key Support</span>
                            <span className="np-value green">
                              ₹{nearestSupport?.value?.toFixed(2)}
                            </span>
                          </div>
                        </div>

                       
                        <div className="np-col">
                          <div className="np-row">
                            <span className="np-label">LTP</span>
                            <span className="np-value">
                              ₹{quote?.last_price}
                            </span>
                          </div>

                          <div className="np-row">
                            <span className="np-vwap">VWAP</span>
                            <span className="np-value blue">
                              ₹{latestVWAP?.toFixed(2)}
                            </span>
                          </div>

                          <div className="np-row">
                            <span className="np-stop">Stop Loss</span>
                            <span className="np-value gray">
                              ₹{analysis?.stopLoss}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div> */}
                    {/* Summary box between insight and max-pain */}
                    {/* <div className="tp-card tp-critical-card">
                      <h4 className="tp-title">SUMMARY</h4>

                      <div className="tp-summary-box">
                        {analysis?.signal && (
                          <p className="tp-signal-text buy">
                            {analysis.signal}
                          </p>
                        )}
                   
                        {analysis?.exit && (
                          <p className="tp-signal-text sell">{analysis.exit}</p>
                        )}
                        <p className="tp-note-text">{analysis?.traderNote}</p>
                      </div>
                    </div> */}
                    <div className="tp-card  tp-insight">
                      <h4 className="tp-title insight-critical-title">
                        <span className="tp-insight-span">
                          Near Pivots ⭐ ⭐ ⭐{" "}
                          <span style={{ color: "#2563eb" }}>
                            LTP - ₹{quote?.last_price}
                          </span>
                        </span>
                      </h4>

                      <div className="near-pivot-grid">
                        <div className="np-card np-pivot-row">
                          <span className="np-label">Key Resistance</span>
                          <span className="np-value red">
                            {nearestResistance?.value
                              ? `₹${nearestResistance.value.toFixed(2)}`
                              : "All Broken"}
                          </span>
                        </div>

                        <div className="np-card">
                          <span className="np-label">Key Support</span>
                          <span className="np-value green">
                            ₹{nearestSupport?.value?.toFixed(2)}
                          </span>
                        </div>

                        <div className="np-card">
                          <span className="np-label">VWAP</span>
                          <span className="np-value blue">
                            ₹{latestVWAP?.toFixed(2)}
                          </span>
                        </div>

                        <div className="np-card">
                          <span className="np-label">Stop Loss</span>
                          <span className="np-value gray">
                            ₹{analysis?.stopLoss}
                          </span>
                        </div>
                      </div>
                    </div>
                    {/* option chain and max-pain */}
                    {/* <div className="max-option">
                      <div
                        className="option-chain-div
                "
                      >
                        <p>Option Chain</p>
                        <div className="option-chain-inner-div">
                          <button
                            className="rec-btn"
                            onClick={() => {
                              navigate(`/optionpage/${companyCode}`);
                            }}
                          >
                            View
                          </button>
                        </div>
                      </div>
                      <div
                        className="option-chain-div
                "
                      >
                        <p>Max Pain</p>
                        <div className="option-chain-inner-div">
                          <button
                            className="rec-btn"
                            onClick={() => {
                              navigate(`/maxpainpage/${companyCode}`);
                            }}
                          >
                            View
                          </button>
                        </div>
                      </div>
                    </div> */}
                  </div>
                  {/* 
                  <div>
                    {
                     

                      <div className="tp-container">
                       
                        <div className="tp-card tp-entry">
                          <h4 className="tp-title">ENTRY ZONE</h4>

                          <div className="analysis-text">
                            <h2
                              className={`tp-signal tp-${analysis?.entry?.type}`}
                            >
                              {analysis?.entry?.label}
                            </h2>
                            <p className="tp-subtext">{analysis?.entry?.msg}</p>

                            <p className="tp-meta">
                              VWAP ₹{latestVWAP?.toFixed(2)}
                            </p>
                          </div>
                        </div>

                        
                        <div className="tp-card tp-target">
                          <h4 className="tp-title">EXIT TARGETS</h4>

                         
                          <div className="tp-pill-row">
                            <span className="tp-badge tp-t1">T1</span>

                            <div className="tp-pill">
                              {analysis?.targets?.t1?.label}
                              {" (Resistance)"} : ₹
                              {analysis?.targets?.t1?.value?.toFixed(2)}
                              <span className="tp-pill-type">(Primary)</span>
                            </div>
                          </div>

                         
                          <div className="tp-pill-row">
                            <span className="tp-badge tp-t2">T2</span>

                            <div className="tp-pill">
                              {analysis?.targets?.t2?.label}
                              {" (Support)"} : ₹
                              {analysis?.targets?.t2?.value?.toFixed(2)}
                              <span className="tp-pill-type">(Aggressive)</span>
                            </div>
                          </div>

                         
                        </div>

                        
                        <div className="tp-card tp-stop">
                          <h4 className="tp-title">STOP LOSS</h4>
                          <div className="analysis-text">
                            <h2 className="tp-stop-value">
                              ₹{analysis?.stopLoss}
                            </h2>

                            <p className="tp-subtext">Based on VWAP</p>
                          </div>
                        </div>
                      </div>
                    }
                    {
                      // analysis &&

                      <div className="tp-note-container">
                       

                  

                        <div className="tp-critical">
                          <h5>⭐ Critical Levels</h5>

                         
                        </div>
                      </div>
                    }
                  </div> */}
                  <div className="factor-box">
                    {/* <h4>
                  
                      Vwap Entry Exit Stop Loss
                    </h4> */}

                    {/* <h4>Vwap Entry Exit Stop Loss</h4> */}

                    <div className="vwap-entry-exit">
                      <div className="factor-box vwap-factor-box">
                        <h4>Vwap Entry Exit Stop Loss</h4>
                        <div className="tp-row-container">
                          <div className="tp-card tp-entry">
                            <h4 className="tp-title">ENTRY ZONE</h4>

                            <div className="tp-entry-content">
                              <div className="tp-entry-top">
                                <h2
                                  className={`tp-signal tp-${analysis?.entry?.type}`}
                                >
                                  {analysis?.entry?.label}
                                </h2>
                              </div>
                              <span className="tp-vwap-inline">
                                <span>VWAP</span>₹{latestVWAP?.toFixed(2)}
                              </span>
                              <span className="tp-inline-text">
                                {analysis?.entry?.msg}
                              </span>
                            </div>
                          </div>

                          <div className="tp-card tp-target">
                            <h4 className="tp-title">EXIT TARGETS</h4>

                            <div className="tp-target-block">
                              <div className="tp-target-row">
                                <span className="tp-target-label">
                                  {nearestResistance?.key} (Resistance)
                                </span>

                                <span className="tp-target-value">
                                  {nearestResistance?.value
                                    ? `₹${nearestResistance.value.toFixed(2)}`
                                    : "All Broken"}
                                </span>
                              </div>

                              <p className="tp-target-type">(Primary)</p>
                            </div>

                            <div className="tp-target-block">
                              <div className="tp-target-row">
                                <span className="tp-target-label">
                                  {nearestSupport?.key} (Support)
                                </span>

                                <span className="tp-target-value">
                                  ₹{nearestSupport?.value?.toFixed(2)}
                                </span>
                              </div>

                              <p className="tp-target-type">(Aggressive)</p>
                            </div>
                          </div>

                          <div className="tp-card tp-stop">
                            <h4 className="tp-title">STOP LOSS</h4>

                            <div className="tp-stop-content">
                              <h2 className="tp-stop-value">
                                ₹{analysis?.stopLoss}
                              </h2>
                              <p className="tp-subtext">Based on VWAP</p>
                            </div>
                          </div>
                          <div className="tp-card tp-critical-card">
                            {/* <h4 className="tp-title">SUMMARY</h4> */}
                            <h4 className="tp-title">SUMMARY</h4>

                            <div className="tp-summary-box">
                              {analysis?.signal && (
                                <p className="tp-signal-text buy">
                                  {analysis.signal}
                                  <InfoTooltip
                                    text={getSignalTooltip(analysis?.signal)}
                                  />
                                </p>
                              )}

                              {analysis?.exit && (
                                <p className="tp-signal-text sell">
                                  {analysis.exit}
                                </p>
                              )}

                              <span className="tp-vwap-inline">
                                <span>{analysis?.pythonTrend}</span>
                              </span>
                              <span className="tp-inline-text">
                                {analysis?.traderNote}
                              </span>
                            </div>
                          </div>

                          {/* <div className="tp-card tp-critical-card">
                        <h4 className="tp-title">SUMMARY</h4>

                        <div className="tp-summary-box">
                          {analysis?.signal && (
                            <p className="tp-signal-text buy">
                              {analysis.signal}
                            </p>
                          )}
                          🔴 EXIT SIGNAL
                          {analysis?.exit && (
                            <p className="tp-signal-text sell">
                              {analysis.exit}
                            </p>
                          )}

                          <p className="tp-note-text">{analysis?.traderNote}</p>
                        </div>
                      </div> */}

                          {/* Near Pivots  */}
                          {/* <div className="tp-card  tp-insight">
                          <h4 className="tp-title insight-critical-title">
                            <span className="tp-insight-span">
                              Near Pivots ⭐ ⭐ ⭐{" "}
                              <span>LTP - ₹{quote?.last_price}</span>
                            </span>
                          </h4>

                          <div className="near-pivot-grid">
                            <div className="np-card np-pivot-row">
                              <span className="np-label">Key Resistance</span>
                              <span className="np-value red">
                                {nearestResistance?.value
                                  ? `₹${nearestResistance.value.toFixed(2)}`
                                  : "All Broken"}
                              </span>
                            </div>

                            <div className="np-card">
                              <span className="np-label">Key Support</span>
                              <span className="np-value green">
                                ₹{nearestSupport?.value?.toFixed(2)}
                              </span>
                            </div>

                            <div className="np-card">
                              <span className="np-label">VWAP</span>
                              <span className="np-value blue">
                                ₹{latestVWAP?.toFixed(2)}
                              </span>
                            </div>

                            <div className="np-card">
                              <span className="np-label">Stop Loss</span>
                              <span className="np-value gray">
                                ₹{analysis?.stopLoss}
                              </span>
                            </div>
                          </div>
                        </div> */}
                        </div>
                      </div>

                      <div className="max-option">
                        <div
                          className="option-chain-div
                "
                        >
                          <p>Option Chain</p>
                          <div className="option-chain-inner-div">
                            <button
                              className="rec-btn"
                              onClick={() => {
                                navigate(`/optionpage/${companyCode}`);
                              }}
                            >
                              View
                            </button>
                          </div>
                        </div>
                        <div
                          className="option-chain-div
                "
                        >
                          <p>Max Pain</p>
                          <div className="option-chain-inner-div">
                            <button
                              className="rec-btn"
                              onClick={() => {
                                navigate(`/maxpainpage/${companyCode}`);
                              }}
                            >
                              View
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="factor-box">
                      <h4 className="pivot-level-head">
                        Pivot Levels
                        <span
                          style={{
                            display: "flex",
                            justifyContent: "end",
                            // margin: "10px 0",
                          }}
                        >
                          <div className="chart-select">
                            <label>Interval</label>
                            <select
                              name=""
                              id=""
                              value={resistTimeFrame}
                              onChange={(e) =>
                                setResistTimeFrame(e.target.value)
                              }
                              style={{
                                background: "inherit",
                                // color: "white",
                                fontWeight: "600",
                                color: "black",
                                // boxShadow: "0px 2px 8px rgba(255, 255, 255, 0.2)",
                                boxShadow: " 0 4px 12px rgba(0, 0, 0, 0.4)",
                                padding: "5px 7px",
                                borderRadius: "10px",
                              }}
                            >
                              <option value="week">Weekly</option>
                              <option value="day">Day</option>
                            </select>
                          </div>
                        </span>
                      </h4>

                      <div className="pivot-container">
                        <table className="pivot-table ma-table">
                          <thead>
                            <tr>
                              <th>Pivot</th>
                              <th>Priority</th>
                              <th>Status</th>
                              <th>Classic</th>
                              <th>Fibonacci</th>
                              <th>Camarilla</th>
                              <th>Woodie</th>
                              <th>DM</th>
                            </tr>
                          </thead>
                          {/* 
                        <tbody>
                          {levels?.map((level) => (
                            <tr key={level?.key}>
                              <td data-label="Pivot">
                                {level?.key} {`(${level?.label})`}
                              </td>

                              <td data-label="Classic">
                                {resistanceDataToRender?.classic?.[
                                  level?.key
                                ]?.toFixed(2) ?? "—"}
                              </td>

                              <td data-label="Fibonacci">
                                {resistanceDataToRender?.fib?.[
                                  level?.key
                                ]?.toFixed(2) ?? "—"}
                              </td>

                              <td data-label="Camarilla">
                                {resistanceDataToRender?.cam?.[
                                  level?.key
                                ]?.toFixed(2) ?? "—"}
                              </td>

                              <td data-label="Woodie">
                                {resistanceDataToRender?.woodie?.[
                                  level?.key
                                ]?.toFixed(2) ?? "—"}
                              </td>

                              <td data-label="DM">
                                {resistanceDataToRender?.demark?.[
                                  level?.key
                                ]?.toFixed(2) ?? "—"}
                              </td>
                            </tr>
                          ))}
                        </tbody> */}
                          <tbody>
                            {levels?.map((level) => {
                              const classicValue =
                                resistanceDataToRender?.classic?.[level?.key];

                              const status = getStatus(classicValue, ltp);
                              const priority = getPriority(classicValue, ltp);

                              return (
                                <tr key={level?.key}>
                                  {/* Pivot */}

                                  <td className="pivot-td-row">
                                    <span>
                                      {level?.key} ({level?.label})
                                    </span>
                                  </td>

                                  {/* ⭐ Priority */}
                                  <td
                                    className="pivot-td-row"
                                    style={{ textAlign: "center" }}
                                  >
                                    <p className="render-stars">
                                      {renderStars(priority)}
                                    </p>
                                  </td>

                                  {/* 📊 Status */}
                                  <td
                                    className="pivot-td-row"
                                    style={{
                                      fontWeight: "600",
                                      color:
                                        status === "Above LTP"
                                          ? "#dc2626" // red
                                          : status === "Below LTP"
                                            ? "#16a34a" // green
                                            : "#6b7280", // gray
                                    }}
                                  >
                                    <span>{status}</span>
                                  </td>

                                  {/* Classic */}
                                  <td className="pivot-td-row">
                                    <span>
                                      {classicValue?.toFixed(2) ?? "—"}
                                    </span>
                                  </td>

                                  {/* Fibonacci */}
                                  <td className="pivot-td-row">
                                    <span>
                                      {resistanceDataToRender?.fib?.[
                                        level?.key
                                      ]?.toFixed(2) ?? "—"}
                                    </span>
                                  </td>

                                  {/* Camarilla */}
                                  <td>
                                    <span>
                                      {resistanceDataToRender?.cam?.[
                                        level?.key
                                      ]?.toFixed(2) ?? "—"}
                                    </span>
                                  </td>

                                  {/* Woodie */}
                                  <td>
                                    <span>
                                      {resistanceDataToRender?.woodie?.[
                                        level?.key
                                      ]?.toFixed(2) ?? "—"}
                                    </span>
                                  </td>

                                  {/* DM */}
                                  <td>
                                    <span>
                                      {resistanceDataToRender?.demark?.[
                                        level?.key
                                      ]?.toFixed(2) ?? "—"}
                                    </span>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div className="price-summary">
                    {/* <div className="price-chip">
                      <p className="label">LTP</p>
                      <h3 className="value">₹{quote?.last_price}</h3>
                    </div>
                    <div className="price-chip">
                      <p className="label">% Change</p>
                      <h3
                        className="value positive"
                        style={{
                          color: percent_change > 0 ? "#249966" : "#f87171",
                        }}
                      >
                        {percent_change}%
                      </h3>
                    </div> */}
                    {/* <div className="stock-test-oc">
                      <div className="price-chip">
                        <p className="label">Open</p>
                        <h3 className="value">₹{stock?.open}</h3>
                      </div>
                      <div className="price-chip">
                        <p className="label">Close</p>
                        <h3 className="value">₹{prev_close}</h3>
                      </div>
                    </div> */}

                    <div className="price-scales">
                      <div className="scale-block">
                        <div className="label">Forecast Range</div>
                        <div className="range-svg-wrapper">
                          <RangeBarSVG
                            title="Forecast Range"
                            low={target_low}
                            high={target_high}
                            ltp={target_price}
                            variant={variant}
                            price={quote?.last_price}
                            type="target"
                          />
                        </div>
                      </div>
                    </div>

                    {/* <div className="price-chip">
                      <p className="label">Low</p>
                      <h3 className="value">₹{stock?.low}</h3>
                    </div>
                    <div className="price-chip">
                      <p className="label">High</p>
                      <h3 className="value">₹{stock?.high}</h3>
                    </div> */}
                    {/* <div className="price-scales">
                      <div className="scale-block">
                        <div className="scale-title">Day Range</div>

                        <div className="scale-values">
                          <span className="value-left">{stock?.low}</span>
                          <span className="value-right">{stock?.high}</span>
                        </div>

                        <div className="scale-axis">
                          <div className="axis-end left">
                            <div className="axis-line">L</div>
                          </div>

                          <div
                            className="axis-marker"
                            style={{ left: `${dayPosition}%`, color: "blue" }}
                          >
                            <div
                              className="axis-line"
                              style={{ color: "#047cc2" }}
                            >
                              |
                            </div>
                           
                          </div>

                          <div className="axis-end right">
                            <div className="axis-line">H</div>
                          </div>
                        </div>
                      </div>
                    </div> */}
                    {/* Day Range */}
                    {/* <div className="price-scales">
                      <div className="scale-block">
                        <div className="label">Day Range</div>

                        <div className="scale-values">
                          <span className="value-left">{stock?.low}</span>
                          <span className="value-right">{stock?.high}</span>
                        </div>

                        <div className="scale-wrapper">
                          <div className="scale-line-container">
                            <span className="scale-edge low">L</span>
                            <div className="scale-line"></div>
                            <span className="scale-edge high">H</span>
                          </div>

                          <div
                            className="market-marker"
                            style={{ left: `${dayPosition}%` }}
                          >
                            <div className="marker-line">|</div>
                            <div className="axis-marker">
                              {quote?.last_price}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}
                    {/* New Code */}
                    {/* <div className="price-scales">
                      <div className="scale-block">
                        <div className="label">Day Range</div>

                        <div className="scale-values">
                          <span className="value-left">{stock?.low}</span>
                          <span className="value-right">{stock?.high}</span>
                        </div>

                        <div className="scale-wrapper">
                          <div className="scale-line-container">
                            <span className="scale-edge low">L</span>
                            <div className="scale-line"></div>
                            <span className="scale-edge high">H</span>
                          </div>

                          {Number.isFinite(dayLtpPosition) && (
                            <div
                              className="market-marker"
                              style={{ left: `${dayLtpPosition}%` }}
                            >
                              <div className="marker-line">|</div>
                              <div className="axis-marker">
                               
                                {tempLtp}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="price-scales">
                      <div className="scale-block">
                        <div className="label">Day Range</div>

                        <div className="scale-wrapper">
                          <div className="scale-line"></div>

                          
                          <div className="scale-edge low" style={{ left: "0" }}>
                            L<div className="edge-value">{stock?.low}</div>
                          </div>

                         
                          <div
                            className="scale-edge high"
                            style={{ left: "0" }}
                          >
                            H<div className="edge-value">{stock?.high}</div>
                          </div>

                         
                          <div
                            className="market-marker"
                            style={{ left: `${dayLtpPosition}%` }}
                          >
                            <div className="marker-line">|</div>
                            <div
                              className="axis-marker"
                              style={{
                                color:
                                  tempLtp < stock?.low
                                    ? "#f87171"
                                    : tempLtp > stock?.high
                                      ? "#249966"
                                      : "#374151",
                                fontWeight: 700,
                              }}
                            >
                              {tempLtp}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}

                    <div className="price-scales">
                      {/* <div className="scale-block">
                        <div className="label">Day Range</div>

                        <div className="scale-values">
                          <span className="value-left">{stock?.low}</span>
                          <span className="value-right">{stock?.high}</span>
                        </div>

                      
                        <div className="scale-wrapper">
                          <div className="scale-line"></div>

                      
                          <div
                            className="market-marker"
                            style={{ left: `${ltpPos}%` }}
                          >
                            <div className="marker-line">|</div>
                            <div className="axis-marker">{tempLtp}</div>
                          </div>

                    
                          <div
                            className="scale-edge low"
                            style={{ left: `${lowPos}%` }}
                          >
                            L<div className="edge-value">{stock.low}</div>
                          </div>

                     
                          <div
                            className="scale-edge high"
                            style={{ left: `${highPos}%` }}
                          >
                            H<div className="edge-value">{stock.high}</div>
                          </div>
                        </div>
                      </div> */}
                      <div className="scale-block">
                        <div className="label">Day Range</div>
                        <div className="range-svg-wrapper">
                          <RangeBarSVG
                            title="Day Range"
                            low={stock?.low}
                            high={stock?.high}
                            ltp={quote?.last_price}
                            price={quote?.last_price}
                            variant={variant}
                            type="price"
                          />
                        </div>
                      </div>
                    </div>

                    {/* 52 Week Range */}
                    {/* <div className="price-scales">
                      <div className="scale-block">
                        <div className="label">52 Week Range</div>

                        <div className="scale-values">
                          <span className="value-left">{weekLow}</span>
                          <span className="value-right">{weekHigh}</span>
                        </div>

                        <div className="scale-wrapper">
                          <div className="scale-line-container">
                            <span className="scale-edge low">L</span>
                            <div className="scale-line"></div>
                            <span className="scale-edge high">H</span>
                          </div>

                          <div
                            className="market-marker"
                            style={{ left: `${weekPosition}%` }}
                          >
                            <div className="marker-line">|</div>
                            <div className="axis-marker">
                              {quote?.last_price}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}
                    {/* New Code */}
                    <div className="price-scales">
                      <div className="scale-block">
                        <div className="label">52 Week Range</div>
                        <div className="range-svg-wrapper">
                          <RangeBarSVG
                            title="52 Week Range"
                            low={weekLow}
                            high={weekHigh}
                            ltp={quote?.last_price}
                            price={quote?.last_price}
                            variant={variant}
                            type="price"
                          />
                        </div>
                        {/* <div className="scale-values">
                          <span className="value-left">{weekLow}</span>
                          <span className="value-right">{weekHigh}</span>
                        </div>

                        <div className="scale-wrapper">
                          <div className="scale-line-container">
                            <span className="scale-edge low">L</span>
                            <div className="scale-line"></div>
                            <span className="scale-edge high">H</span>
                          </div>

                          {Number.isFinite(weekLtpPosition) && (
                            <div
                              className="market-marker"
                              style={{ left: `${weekLtpPosition}%` }}
                            >
                              <div className="marker-line">|</div>
                              <div className="axis-marker">
                                {quote?.last_price}
                              </div>
                            </div>
                          )}
                        </div> */}
                      </div>
                    </div>
                  </div>
                  <div className="factor-box">
                    <h4>Wealth Creator/Destroyer</h4>
                    <div>
                      <div
                        className="return-box"
                        style={
                          {
                            // color: getColor(returns.oneYear),
                          }
                        }
                      >
                        <div className="return-label">
                          <p className="return-p label">1W</p>
                          <div
                            className={`return-value ${
                              oneWeekReturn > 0
                                ? "return-positive"
                                : "return-negative"
                            }`}
                          >
                            {oneWeekReturn > 0 ? "+" : ""}
                            {oneWeekReturn}%
                          </div>
                        </div>

                        <div className="return-label">
                          <p className="return-p label">1M</p>
                          <div
                            className={`return-value ${
                              oneMonthReturn > 0
                                ? "return-positive"
                                : "return-negative"
                            }`}
                          >
                            {oneMonthReturn > 0 ? "+" : ""}
                            {oneMonthReturn}%
                          </div>
                        </div>
                        <div className="return-label">
                          <p className="return-p label">YTD</p>
                          <div
                            className={`return-value ${
                              ytdReturn > 0
                                ? "return-positive"
                                : "return-negative"
                            }`}
                          >
                            {ytdReturn > 0 ? "+" : ""}
                            {ytdReturn}%
                          </div>
                        </div>
                        <div className="return-label">
                          {" "}
                          <p className="return-p label">1Y</p>
                          <div
                            className={`return-value ${
                              oneYearReturn > 0
                                ? "return-positive"
                                : "return-negative"
                            }`}
                          >
                            {oneYearReturn > 0 ? "+" : ""}
                            {oneYearReturn}%
                          </div>
                        </div>
                        <div className="return-label">
                          {" "}
                          <p className="return-p label">3Y</p>
                          <div
                            className={`return-value ${
                              threeYearReturn > 0
                                ? "return-positive"
                                : "return-negative"
                            }`}
                          >
                            {threeYearReturn > 0 ? "+" : ""}
                            {threeYearReturn}%
                          </div>
                        </div>
                        <div className="return-label">
                          <p className="return-p label">5Y</p>
                          <div
                            className={`return-value ${
                              fiveYearReturn > 0
                                ? "return-positive"
                                : "return-negative"
                            }`}
                          >
                            {fiveYearReturn > 0 ? "+" : ""}
                            {fiveYearReturn}%
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <div className="factor-div"> */}
                  <div className="factor-wrapper">
                    <div className="factor-box">
                      <h4>Technical Factors</h4>
                      <div className="inner-factor-box">
                        <div className="factor-row">
                          <p className="label">RSI</p>
                          <span
                            style={{
                              color: latestRSIValue > 0 ? "#249966" : "#f87171",
                            }}
                          >
                            {" "}
                            {latestRSIValue?.toFixed(2)}
                          </span>
                        </div>
                        <div className="factor-row">
                          <p className="label">MACD</p>
                          <span
                            // className="positive"
                            style={{
                              color:
                                latestMACDValue > 0 ? "#249966" : "#f87171",
                            }}
                          >
                            {latestMACDValue?.toFixed(2)}
                          </span>
                        </div>
                        <div className="factor-row">
                          <p className="label">Volume</p>

                          <span> {formatVolume(quote?.volume)}</span>
                        </div>
                        <div className="factor-row">
                          <p className="label">PCR</p>
                          <span>{pcr?.value}</span>
                        </div>
                      </div>
                    </div>

                    <div className="factor-box">
                      <h4>Fundamental Factors</h4>
                      <div className="inner-factor-box">
                        <div className="factor-row">
                          <p className="label">% Upside</p>
                          <span
                            className="positive"
                            style={{
                              color: projectChange > 0 ? "#249966" : "#f87171",
                            }}
                          >
                            {" "}
                            {projectChange}%
                          </span>
                        </div>
                        <div className="factor-row">
                          <p className="label">Forecast Price</p>
                          <span>₹{target_price}</span>
                        </div>
                        <div className="factor-row">
                          <p className="label">P/E Ratio</p>
                          <span>{peRatio}</span>
                        </div>
                        <div className="factor-row">
                          <p className="label">Face Value</p>
                          <span>₹{marketCapData?.faceValue}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* </div> */}

                  {/* <div className="scale-values">
                            <span className="value-left">₹{tLow}</span>
                            <span className="value-right">₹{tHigh}</span>
                          </div> */}

                  {/* <div className="scale-wrapper">
                            <div className="scale-line-container">
                              <span className="scale-edge low">TL</span>
                              <div className="scale-line"></div>
                              <span className="scale-edge high">TH</span>
                            </div>

                            {Number.isFinite(targetPosition) && (
                              <div
                                className="market-marker target"
                                style={{ left: `${targetPosition}%` }}
                              >
                                <div className="marker-line">|</div>
                                <div
                                  className="axis-marker target"
                                  style={{
                                    color: tMean > ltp ? "#249966" : "#f87171",
                                  }}
                                >
                                  ₹{tMean}
                                </div>
                              </div>
                            )}

                            
                            {Number.isFinite(ltpPosition) && (
                              <div
                                className="market-marker ltp"
                                style={{ left: `${ltpPosition}%` }}
                              >
                                <div className="marker-line">|</div>
                                <div className="axis-marker ltp">₹{ltp}</div>
                              </div>
                            )}
                          </div> */}
                  {/* <div className="target-scale">
                        <div className="price-scales">
                          <div className="scale-block">
                           

                            <div className="scale-values">
                              <span className="value-left">₹{tLow}</span>
                              <span className="value-right">₹{tHigh}</span>
                            </div>

                            <div className="scale-wrapper">
                              <div className="scale-line-container">
                                <span className="scale-edge low">TL</span>
                                <div className="scale-line"></div>
                                <span className="scale-edge high">TH</span>
                              </div>

                             
                              <div
                                className="market-marker target"
                                style={{ left: `${targetPosition}%` }}
                              >
                                <div className="marker-line">|</div>
                                <div
                                  className="axis-marker target"
                                  style={{
                                    color: tMean > ltp ? "#249966" : "#f87171",
                                  }}
                                >
                                  {tMean}
                                </div>
                              </div>

                             
                              <div
                                className="market-marker ltp"
                                style={{ left: `${ltpPosition}%` }}
                              >
                                <div className="marker-line">|</div>
                                <div className="axis-marker ltp">{ltp}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                        
                      </div> */}
                  <div className="val-1">
                    <div className="factor-box">
                      <h4>Valuation Measures</h4>
                      <div className="inner-factor-box">
                        <div className="factor-row">
                          <p className="label">Market Cap</p>
                          <span>
                            {" "}
                            {formatMarketCapINR(marketCapData?.marketCap)}
                          </span>
                        </div>
                        <div className="factor-row">
                          <p className="label">Enterprise Value</p>
                          <span> {statisticsData?.enterpriseValue?.fmt}</span>
                        </div>
                        <div className="factor-row">
                          <p className="label">Forward P/E</p>
                          <span>{statisticsData?.forwardPE?.fmt}</span>
                        </div>
                        <div className="factor-row">
                          <p className="label">Price to Book</p>
                          <span>{statisticsData?.priceToBook?.fmt}</span>
                        </div>
                        <div className="factor-row">
                          <p className="label">Enterprise/Revenue</p>
                          <span>
                            {statisticsData?.enterpriseToRevenue?.fmt}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="valuation-div"> */}

                  <div className="factor-wrapper">
                    <div className="factor-box">
                      <h4>Profitability & Growth</h4>
                      <div className="inner-factor-box">
                        <div className="factor-row">
                          <p className="label">Profit Margin</p>
                          <span>{statisticsData?.profitMargins?.fmt}</span>
                        </div>
                        <div className="factor-row">
                          <p className="label">Earnings Growth (QoQ)</p>
                          <span>
                            {statisticsData?.earningsQuarterlyGrowth?.fmt}
                          </span>
                        </div>
                        <div className="factor-row">
                          <p className="label">Trailing EPS</p>
                          <span>{statisticsData?.trailingEps?.fmt}</span>
                        </div>
                        <div className="factor-row">
                          <p className="label">Forward EPS</p>
                          <span>{statisticsData?.forwardEps?.fmt}</span>
                        </div>
                      </div>
                    </div>
                    <div className="factor-box">
                      <h4>Ownership & Risk</h4>
                      <div className="inner-factor-box">
                        <div className="factor-row">
                          <p className="label">Insider Holding %</p>
                          <span>
                            {statisticsData?.heldPercentInsiders?.fmt}
                          </span>
                        </div>
                        <div className="factor-row">
                          <p className="label">Institutional Holding %</p>
                          <span>
                            {statisticsData?.heldPercentInstitutions?.fmt}
                          </span>
                        </div>
                        <div className="factor-row">
                          <p className="label">Float Shares</p>
                          <span>{statisticsData?.floatShares?.fmt}</span>
                        </div>
                        <div className="factor-row">
                          <p className="label">Shares Outstanding</p>
                          <span>{statisticsData?.sharesOutstanding?.fmt}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="factor-box ma-factor-box">
                    <div className="ma-panel">
                      <h4>Moving Averages</h4>
                      <div className="ma-div">
                        <Gauge
                          buy={summary?.finalBuy}
                          sell={summary?.finalSell}
                        />

                        <table className="ma-table pivot-table">
                          <thead>
                            <tr>
                              <th>Name</th>
                              <th>Simple</th>
                              <th></th>
                              <th>Exponential</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            {rows?.length > 0 ? (
                              rows?.map((row) => (
                                <tr key={row?.name}>
                                  <td>
                                    <span>{row?.name}</span>
                                  </td>

                                  <td>
                                    {/* <div className="ma-cell"> */}
                                    <span className="ma-value">
                                      {row?.smaValue.toFixed(2)}
                                    </span>
                                    {/* </div> */}
                                  </td>
                                  <td>
                                    <span
                                      className={
                                        row.smaTrend === "Buy"
                                          ? "ma-trend-buy"
                                          : "ma-trend-sell"
                                      }
                                    >
                                      {row?.smaTrend}
                                    </span>
                                  </td>

                                  <td>
                                    {/* <div className="ma-cell"> */}
                                    <span className="ma-value">
                                      {row?.emaValue?.toFixed(2)}
                                    </span>
                                    {/* </div> */}
                                  </td>
                                  <td>
                                    <span
                                      className={
                                        row?.emaTrend === "Buy"
                                          ? "ma-trend-buy"
                                          : "ma-trend-sell"
                                      }
                                    >
                                      {row?.emaTrend}
                                    </span>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <div className="single-stock-table-row">
                                <span>Loading MA Data...</span>
                              </div>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div className="factor-box">
                    <h4>Order Book</h4>
                    <table className="orderbook-table">
                      <thead>
                        <tr>
                          <th>Qty</th>
                          <th>Bid (₹)</th>
                          <th>Ask (₹)</th>
                          <th>Qty</th>
                        </tr>
                      </thead>

                      <tbody>
                        {Array.from({
                          length: Math.max(
                            depth?.buy?.length || 0,
                            depth?.sell?.length || 0,
                          ),
                        }).map((_, idx) => {
                          const buy = depth?.buy?.[idx];
                          const sell = depth?.sell?.[idx];

                          return (
                            <tr key={idx}>
                              {/* BUY QTY */}
                              <td className="buy-qty">
                                {buy ? buy?.quantity.toLocaleString() : "-"}
                              </td>

                              {/* BUY PRICE */}
                              <td className="buy-price">
                                {buy ? buy.price.toFixed(2) : "-"}
                              </td>

                              {/* SELL PRICE */}
                              <td className="sell-price">
                                {sell ? sell.price.toFixed(2) : "-"}
                              </td>

                              {/* SELL QTY */}
                              <td className="sell-qty">
                                {sell ? sell?.quantity.toLocaleString() : "-"}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>

                    <div className="depth-summary">
                      <div className="depth-bar">
                        <div
                          className="buy-bar"
                          style={{ width: `${buyPercent}%` }}
                        />
                        <div
                          className="sell-bar"
                          style={{ width: `${sellPercent}%` }}
                        />
                      </div>

                      <div className="depth-text">
                        <span className="buy-text">
                          {buyPercent?.toFixed(2)}% Buy
                          <span
                            style={{
                              marginLeft: "5px",
                            }}
                          >{`(${totalBuyQty?.toLocaleString()})`}</span>
                        </span>

                        <span className="total-text">
                          Total Quantity{" "}
                          <strong style={{ marginLeft: "5px" }}>
                            {`(${totalQty.toLocaleString()})`}
                          </strong>
                          {/* <br />
                        <strong>{totalQty.toLocaleString()}</strong> */}
                        </span>

                        <span className="sell-text">
                          {sellPercent?.toFixed(2)}% Sell
                          <span
                            style={{
                              marginLeft: "5px",
                            }}
                          >{`(${totalSellQty?.toLocaleString()})`}</span>
                        </span>
                      </div>

                      {/* <div className="depth-qty">
                      <span className="buy-qty">
                        {totalBuyQty?.toLocaleString()}
                      </span>
                      <span className="sell-qty">
                        {totalSellQty?.toLocaleString()}
                      </span>
                    </div> */}
                    </div>
                  </div>

                  <div className="factor-box">
                    <h4>MACD Crossover</h4>
                    <table className="ma-table pivot-table">
                      <thead>
                        <tr>
                          {/* <th>Type</th> */}
                          <th>Date</th>
                          <th>Price</th>
                          <th>MACD</th>
                          <th>Signal</th>
                          <th>Message</th>
                        </tr>
                      </thead>

                      <tbody>
                        {[...crossovers]
                          .reverse()

                          .map((row, i) => (
                            <tr key={i}>
                              {/* <td>
                                <span
                                  style={{
                                    color:
                                      row.type === "BUY"
                                        ? "#22c55e"
                                        : "#ef4444",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {row.type}
                                </span>
                              </td> */}

                              <td>{row.date}</td>

                              <td>₹{row.price?.toFixed(2)}</td>

                              <td>{row.macd?.toFixed(2)}</td>

                              <td>{row.signal?.toFixed(2)}</td>

                              <td>
                                {row.type === "BUY"
                                  ? "MACD Bullish Crossover"
                                  : "MACD Bearish Crossover"}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="factor-box">
                    <table className="ma-table pivot-table">
                      <thead>
                        <tr>
                          <th>Entry</th>
                          <th>Buy</th>
                          <th>Exit</th>
                          <th>Sell</th>
                          <th>P/L %</th>
                          <th>Max Profit %</th>
                          <th>Status</th>
                        </tr>
                      </thead>

                      <tbody>
                        {trades.map((trade, idx) => (
                          <tr key={idx}>
                            <td>{trade.entryDate}</td>

                            <td>₹{trade.entryPrice?.toFixed(2)}</td>

                            <td>{trade.exitDate || "-"}</td>

                            <td>
                              {trade.exitPrice
                                ? `₹${trade.exitPrice.toFixed(2)}`
                                : "-"}
                            </td>

                            <td
                              style={{
                                color:
                                  Number(trade.pnl) >= 0
                                    ? "#22c55e"
                                    : "#ef4444",
                              }}
                            >
                              {trade.pnl}%
                            </td>

                            <td>{trade.maxProfit}%</td>

                            <td>{trade.status}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {macdChartData && macdChartData.length > 0 && (
                <div className="macd-chart-graph">
                  <div className="chart-top-heading">
                    <h3>Price, MACD Line, Signal & Histogram</h3>
                    <div className="chart-select">
                      <label>Interval</label>
                      <div style={{ display: "flex", gap: "10px" }}>
                        <select
                          name=""
                          id=""
                          value={timeFrame}
                          onChange={(e) => setTimeFrame(e.target.value)}
                          style={{
                            background: "inherit",
                            // color: "white",
                            fontWeight: "600",
                            color: "black",
                            // boxShadow: "0px 2px 8px rgba(255, 255, 255, 0.2)",
                            boxShadow: " 0 4px 12px rgba(0, 0, 0, 0.4)",
                            padding: "5px 7px",
                            borderRadius: "10px",
                          }}
                        >
                          <option value="min">Minute</option>
                          <option value="day">Day</option>
                        </select>
                        <select
                          value={interval}
                          onChange={(e) => setInterval(e.target.value)}
                          style={{
                            background: "inherit",
                            fontWeight: "600",
                            color: "black",
                            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.4)",
                            padding: "5px 7px",
                            borderRadius: "10px",
                          }}
                        >
                          {timeFrame === "min" && (
                            <>
                              <option value="1m">1 Minute</option>
                              <option value="3m">3 Minutes</option>
                              <option value="5m">5 Minutes</option>
                            </>
                          )}

                          {timeFrame === "day" && (
                            <>
                              <option value="1d">1 Day</option>
                              <option value="1w">1 Week</option>
                              <option value="1mo">1 Month</option>
                              <option value="3mo">3 Months</option>
                            </>
                          )}
                        </select>
                      </div>
                    </div>
                  </div>

                  <h3 className="trend-head">Macd Trend</h3>
                  <ResponsiveContainer width="100%" height={300}>
                    <ComposedChart data={selectedData} syncId="stock-sync">
                      <CartesianGrid strokeDasharray="3 3" stroke="#374151" />

                      {/* X-Axis */}
                      {/* <XAxis
                                dataKey="date"
                                tickFormatter={(date) => {
                                  const d = parseISO(date);
                                  // Only show the month label on the 1st of each month
                                  if (format(d, "dd") === "01") {
                                    return format(d, "MMM"); // "May", "Jun", "Jul"
                                  }
                                  return ""; // hide all other ticks
                                }}
                                tick={{ fill: "#fff", fontWeight: "bold" }}
                                axisLine={{ stroke: "#fff" }}
                                tickLine={{ stroke: "#fff" }}
                              /> */}
                      {/* <XAxis
                                dataKey="date"
                                tickFormatter={(date, index) => {
                                  if (!date) return "";
          
                                  try {
                                    const hasTime = date.includes(":");
                                    const d = new Date(date.replace(" ", "T"));
                                    // ensures consistent parsing
                                    console.log("D:", d);
          
                                    if (hasTime) {
                                      // ⏱ Case 1: Intraday data → show time every 30 minutes (roughly index % 15)
                                      return index % 15 === 0
                                        ? d.toLocaleTimeString("en-IN", {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                            hour12: false,
                                          })
                                        : "";
                                    } else {
                                      // 📅 Case 2: Daily data → show date every 10 days
                                      return index % 10 === 0
                                        ? d.toLocaleDateString("en-IN", {
                                            day: "2-digit",
                                            month: "short",
                                          })
                                        : "";
                                    }
                                  } catch {
                                    return "";
                                  }
                                }}
                                tick={{ fill: "#fff", fontWeight: "bold" }}
                                axisLine={{ stroke: "#fff" }}
                                tickLine={{ stroke: "#fff" }}
                              /> */}
                      {/* <XAxis
                                dataKey="date"
                                tickFormatter={(date, index) => {
                                  if (!date || typeof date !== "string") return "";
                                  try {
                                    const hasTime = date.includes(":");
                                    // const safeDate = date.replace(" ", "T");
                                    const d = new Date(date.replace(" ", "T"));
                                    // console.log("Safedate", safeDate);
                                    // const d = new Date(safeDate);
                                    // console.log("D", d);
          
                                    // if (isNaN(d.getTime())) return ""; // invalid date guard
          
                                    // Intraday → show every 30 mins
                                    if (hasTime) {
                                      const timeLabel =
                                        index % 15 === 0
                                          ? d.toLocaleTimeString("en-IN", {
                                              hour: "2-digit",
                                              minute: "2-digit",
                                              hour12: false,
                                            })
                                          : "";
          
                                      // console.log(`Tick ${index}:`, {
                                      //   date,
                                      //   formatted: timeLabel,
                                      // });
                                      return timeLabel;
                                    }
          
                                    // Daily → show every 10th day
                                    return index % 10 === 0
                                      ? d.toLocaleDateString("en-IN", {
                                          day: "2-digit",
                                          month: "short",
                                        })
                                      : "";
                                  } catch {
                                    return "";
                                  }
                                }}
                                tick={{
                                  // fill: "#fff",
                                  fontWeight: "bold",
                                  fontSize: 10,
                                }}
                                axisLine={{ stroke: "#fff" }}
                                tickLine={{ stroke: "#fff" }}
                              /> */}
                      {/* <XAxis
                        dataKey="date"
                        tickFormatter={(date, index) => {
                          if (!date || typeof date !== "string") return "";

                          let d;

                          // 🔴 APPLY FIX ONLY FOR MINUTE DATA
                          if (timeFrame === "min") {
                            // "7/1/2026, 9:15:00 am" → "7/1/2026 9:15:00 am"
                            const safe = date.replace(",", "");
                            d = new Date(safe);
                            console.log("d", d);
                          } else {
                            // Daily data (already ISO or clean)
                            d = new Date(date);
                          }

                          if (isNaN(d.getTime())) return "";

                          // ⏱ INTRADAY FORMAT
                          if (timeFrame === "min") {
                            return index % 3 === 0
                              ? d.toLocaleTimeString("en-IN", {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: false,
                                })
                              : "";
                          }

                          // 📅 DAILY FORMAT
                          return index % 5 === 0
                            ? d.toLocaleDateString("en-IN", {
                                day: "2-digit",
                                month: "short",
                              })
                            : "";
                        }}
                        tick={{ fontWeight: "bold", fontSize: 10 }}
                        axisLine={{ stroke: "#fff" }}
                        tickLine={{ stroke: "#fff" }}
                      /> */}
                      <XAxis
                        dataKey="date"
                        tickFormatter={(date, index) => {
                          if (!date) return ""; // ✅ ONLY REQUIRED CHANGE

                          // if (timeFrame === "min") {
                          //   const safe = date.replace(",", "");
                          //   d = new Date(safe);
                          // } else {
                          //   d = new Date(date);
                          // }

                          // if (isNaN(d.getTime())) return "";

                          // if (timeFrame === "min") {
                          //   return index % 3 === 0
                          //     ? d.toLocaleTimeString("en-IN", {
                          //         hour: "2-digit",
                          //         minute: "2-digit",
                          //         hour12: false,
                          //       })
                          //     : "";
                          // }
                          // ⏱ MINUTE: extract time directly (NO Date parsing)
                          if (timeFrame === "min") {
                            if (typeof date === "string") {
                              // "24/2/2026, 12:35:00 pm" → "12:35"
                              const timePart = date?.split(",")[1]?.trim(); // "12:35:00 pm"
                              if (!timePart) return "";

                              const [hhmm] = timePart.split(":"); // "12"
                              const minute = timePart.split(":")[1]; // "35"

                              return index % 10 === 0
                                ? `${hhmm}:${minute}`
                                : "";
                            }
                            return "";
                          }
                          const d = new Date(date);
                          if (isNaN(d.getTime())) return "";
                          return index % 15 === 0
                            ? d?.toLocaleDateString("en-IN", {
                                day: "2-digit",
                                month: "short",
                              })
                            : "";
                        }}
                        tick={{ fontWeight: "bold", fontSize: 10 }}
                        axisLine={{ stroke: "#fff" }}
                        tickLine={{ stroke: "#fff" }}
                      />

                      {/* Y-Axis */}
                      <YAxis
                        tick={{
                          //  fill: "#fff",

                          fontWeight: "bold",
                          fontSize: 10,
                        }}
                        axisLine={{ stroke: "#fff" }}
                        tickLine={{ stroke: "#fff" }}
                      />

                      {/* Tooltip */}
                      {/* <Tooltip
                                contentStyle={{
                                  backgroundColor: "#1f2937",
                                  border: "none",
                                }}
                                labelStyle={{ color: "#fff", fontWeight: "bold" }}
                                itemStyle={{ color: "#fff" }}
                                labelFormatter={(date) => {
                                  // full date inside tooltip → "May 19, 2025"
                                  const d = parseISO(date);
                                  return format(d, "MMM dd, yyyy");
                                }}
                              /> */}
                      <Tooltip
                        contentStyle={{
                          backgroundColor: "#1f2937",
                          border: "none",
                          color: "#fff",
                        }}
                        labelFormatter={(label) => {
                          try {
                            if (!label) return "";
                            const hasTime = label.includes(":");
                            const d = new Date(label.replace(" ", "T"));
                            if (isNaN(d.getTime())) return label;

                            if (hasTime) {
                              // ⏱ Intraday case → show date + time
                              return d.toLocaleString("en-IN", {
                                day: "2-digit",
                                month: "short",
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: false,
                              });
                            } else {
                              // 📅 Daily case → show only date
                              return d.toLocaleDateString("en-IN", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              });
                            }
                          } catch (err) {
                            return label;
                          }
                        }}
                        formatter={(value, name) => {
                          if (value == null) return ["–", name];

                          return [
                            Number(value).toFixed(2), // 🔥 FIX DECIMALS
                            name === "MACD"
                              ? "MACD"
                              : name === "signal"
                                ? "Signal"
                                : "Histogram",
                          ];
                        }}
                        labelStyle={{ color: "#fff", fontWeight: "bold" }}
                        itemStyle={{ color: "#fff" }}
                      />

                      {/* <Legend
                                wrapperStyle={{ color: "#fff", fontWeight: "bold" }}
                              /> */}
                      <Legend
                        wrapperStyle={{ fontWeight: "bold" }}
                        payload={[
                          {
                            value: "Histogram (Bullish)", // custom label
                            type: "square",
                            color: "#2fd18a", // green for positive
                          },
                          {
                            value: "Histogram (Bearish)",
                            type: "square",
                            color: "#f87171", // red for negative
                          },
                          {
                            value: "MACD",
                            type: "line",
                            color: "#2563eb", // blue line
                          },
                          {
                            value: "Signal",
                            type: "line",
                            color: "#f59e0b", // orange line
                          },
                        ]}
                      />

                      {/* Histogram bars */}
                      {/* <Bar
                                dataKey="histogram"
                                name="Histogram"
                                // name={null}
                                barSize={20}
                                shape={(props) => {
                                  const { x, y, width, height, value } = props;
                                  return (
                                    <rect
                                      x={x}
                                      y={value >= 0 ? y : y - height}
                                      width={width}
                                      height={Math.abs(height)}
                                      fill={value >= 0 ? "#2fd18a" : "#f87171"}
                                    />
                                  );
                                }}
                              /> */}
                      {/* <Bar
                    dataKey="histogram"
                    name="Histogram"
                    barSize={20}
                    shape={(props) => {
                      const { x, y, width, height, value } = props;
                      return (
                        <rect
                          x={x}
                          y={y}
                          width={width}
                          height={height}
                          fill={value >= 0 ? "#2fd18a" : "#f87171"}
                        />
                      );
                    }}
                  /> */}
                      <Bar
                        dataKey="histogram"
                        name="Histogram"
                        barSize={20}
                        shape={(props) => {
                          const { x, y, width, height, value } = props;

                          const barHeight = Math.abs(height);

                          return (
                            <rect
                              x={x}
                              y={value >= 0 ? y : y - barHeight} // 🔥 key fix
                              width={width}
                              height={barHeight} // 🔥 absolute height
                              fill={value >= 0 ? "#2fd18a" : "#f87171"}
                            />
                          );
                        }}
                      />

                      {/* MACD Line */}
                      <Line
                        type="monotone"
                        dataKey="MACD"
                        stroke="#2563eb"
                        strokeWidth={2}
                        dot={false}
                        name="MACD"
                      />

                      {/* Signal Line */}
                      <Line
                        type="monotone"
                        dataKey="signal"
                        stroke="#f59e0b"
                        strokeWidth={2}
                        dot={false}
                        name="Signal"
                      />
                    </ComposedChart>
                  </ResponsiveContainer>
                  <h3 className="trend-head">Price Trend</h3>
                  <ResponsiveContainer width="100%" height={300}>
                    <ComposedChart
                      data={selectedPriceData}
                      syncId="stock-sync" // 🔥 LINKS WITH MACD & RSI
                    >
                      <CartesianGrid strokeDasharray="3 3" stroke="#374151" />

                      {/* X-Axis (SAME AS MACD) */}
                      <XAxis
                        dataKey="date"
                        tickFormatter={(date, index) => {
                          if (!date) return "";

                          // ⏱ MINUTE
                          if (timeFrame === "min" && typeof date === "string") {
                            const timePart = date.split(",")[1]?.trim(); // "12:35:00 pm"
                            if (!timePart) return "";

                            const [hh, mm] = timePart.split(":");
                            return index % 10 === 0 ? `${hh}:${mm}` : "";
                          }

                          // 📅 DAY
                          const d = new Date(date);
                          return index % 15 === 0
                            ? d.toLocaleDateString("en-IN", {
                                day: "2-digit",
                                month: "short",
                              })
                            : "";
                        }}
                        tick={{ fontWeight: "bold", fontSize: 10 }}
                        axisLine={{ stroke: "#fff" }}
                        tickLine={{ stroke: "#fff" }}
                      />

                      {/* Y-Axis */}
                      <YAxis
                        tick={{ fontWeight: "bold", fontSize: 10 }}
                        axisLine={{ stroke: "#fff" }}
                        tickLine={{ stroke: "#fff" }}
                        domain={["auto", "auto"]}
                      />

                      {/* Tooltip (SAME AS MACD) */}
                      <Tooltip
                        contentStyle={{
                          backgroundColor: "#1f2937",
                          border: "none",
                          color: "#fff",
                        }}
                        labelFormatter={(label) => {
                          if (!label) return "";

                          const hasTime = label.includes(":");
                          const d = new Date(label.replace(" ", "T"));

                          if (isNaN(d.getTime())) return label;

                          return hasTime
                            ? d.toLocaleString("en-IN", {
                                day: "2-digit",
                                month: "short",
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: false,
                              })
                            : d.toLocaleDateString("en-IN", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              });
                        }}
                        formatter={(value) => [
                          Number(value).toFixed(2), // value
                          "Price", // 🔥 rename Close Price → Price
                        ]}
                        labelStyle={{ color: "#fff", fontWeight: "bold" }}
                        itemStyle={{ color: "#fff" }}
                      />
                      <Legend
                        wrapperStyle={{ fontWeight: "bold" }}
                        payload={[
                          {
                            value: "Price",
                            type: "line",
                            color: "#22c55e", // same green as price line
                          },
                        ]}
                      />
                      {/* PRICE LINE */}
                      <Line
                        type="monotone"
                        dataKey="close"
                        stroke="#22c55e"
                        strokeWidth={2}
                        dot={false}
                        name="Close Price"
                      />
                    </ComposedChart>
                  </ResponsiveContainer>

                  <div className="candle-chart-container">
                    <div className="chart-legend">
                      <h3 className="trend-head">Candles Trend</h3>
                      <div className="candles-color-map">
                        <span className="legend-item vwap">🟡 VWAP</span>
                        <span className="legend-item buy">🟢 BUY Signal</span>
                        <span className="legend-item sell">🔴 SELL Signal</span>
                      </div>
                    </div>
                    <CandleChart
                      intradayData={intradayVwap}
                      histData={indicatorData}
                      setLastUTSignal={setLastUTSignal}
                      width={"100%"}
                    />
                  </div>
                </div>
              )}

              <div className="factor-box">
                <h4>News</h4>
                <div className="news-grid stock-news-detail">
                  {newsData &&
                    newsData?.body
                      ?.slice(0, visibleCount)
                      ?.map((item, index) => (
                        <a
                          key={index}
                          href={item.link} // ✅ FIX
                          target="_blank"
                          rel="noopener noreferrer"
                          className="news-card"
                        >
                          <div className="news-content">
                            <h3 className="news-title">{item.title}</h3>

                            <div className="news-timestamp">
                              <p className="news-time">
                                {new Date(item.pubDate).toLocaleString("en-IN")}
                              </p>

                              <p className="news-time">
                                Source - {item.source}
                              </p>
                            </div>
                          </div>
                        </a>
                      ))}
                </div>

                {visibleCount < newsData?.body?.length && (
                  <div className="view-more-container">
                    <button
                      className="rec-btn"
                      onClick={() => setVisibleCount((prev) => prev + 4)}
                    >
                      View More
                    </button>
                  </div>
                )}
              </div>

              {/* {peerCompany && (
                <div className="peer-list card">
                  <h1>Peer Company Stocks for {companyName}</h1>
                  <div className="stock-table-container">
                    <table
                      className="stock-table stacked-mobile"
                      style={{ background: "transparent" }}
                    >
                      <thead style={{ background: "#047cc2", color: "white" }}>
                        <tr>
                          <th>Company</th>
                          <th>Price</th>
                          <th>% Change</th>
                         

                          <th>Recommendation</th>
                        </tr>
                      </thead>
                      <tbody>
                        {peerCompany?.map((stock) => (
                          <tr
                            key={stock?.tickerId}
                            className="stock-row"
                            style={{ background: "transparent" }}
                          >
                            <td
                              className="mobile-name"
                              style={{ color: "black" }}
                            >
                              {stock.companyName}
                            </td>
                            <td
                              className="mobile-pair"
                              data-label="Price"
                              style={{ color: "black" }}
                            >
                              ₹{stock?.price}
                            </td>

                            <td
                              style={{
                                color:
                                  stock.percent_change >= 0
                                    ? "#2fd18a"
                                    : "#f87171",
                                fontWeight: "bold",
                              }}
                              className="mobile-pair"
                              data-label="% Change"
                            >
                              {stock?.percentChange}%
                            </td>
                           

                            <td className="mobile-button">
                              <button
                                className="rec-btn"
                                onClick={() =>
                                  navigate(`/stock/${stock.tickerId}`)
                                }
                              >
                                BUY or SELL
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )} */}
            </div>
            {/* <div className="news-test">
              <h1>Recent News for {companyName}</h1>
              <div className="news-card-grid news-test-grid">
                {testNews?.map((item, id) => (
                  <a
                    key={id}
                    href={item?.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="new-news-card"
                  >
                   
                    <div className="news-image-wrapper news-test-img">
                      <img
                        src={item?.thumbnailImage}
                        alt={item?.headline}
                        className="news-image"
                      />
                    </div>

                   
                    <div className="news-content">
                      <h3 className="news-title">{item?.headline}</h3>

                      <>
                        <p className="news-time">
                          {new Date(item?.date).toLocaleString("en-IN", {
                            dateStyle: "medium",
                            timeStyle: "short",
                          })}
                        </p>
                      </>
                    </div>
                  </a>
                ))}
              </div>
            </div> */}

            {/* <ChatPanel stockContext={stockAISummaryPayload} /> */}
            <ChatPanel2 stockContext={stockAISummaryPayload} />
            <AIFloatButton />
          </div>
        </>
      )}

      <UpgradeModal
        isOpen={showUpgradeModal}
        onClose={() => setShowUpgradeModal(false)}
      />
    </>
  );
};

export default StockTest;
